import { useState, useEffect, useRef, useContext,useCallback,useMemo  } from "react";
import axios from "axios";
import {tcgIdentifyByBase64, sportIdentifyByBase64} from "../../ximilar/ximilarApi";
import Select, { createFilter } from "react-select";
import CreatableSelect from "react-select/creatable";
import { toast } from 'react-toastify';
//import "../CreateCardForm/CreateCardForm.css";
import MySvgButtonPlus from "../UsefulComponent/MySvgButtonPlus";
import { UserContext } from "../login/LoginForm";
import { AuthContext } from "../login/AuthContext";
import { useNavigate,useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "../../assets/css/DoubleSlider.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import debounce from "lodash/debounce";
import BigShowCompleteCard from "../Card/BigShowCompleteCard";
import SeoHelmet from '../../Seo/SeoHelmet';
import loupeIcon from './../../assets/svgs/loupeIcon.svg'
import SelectorIcon from './../../assets/svgs/SelectorIcon.svg'
import {
  faHockeyPuck,
  faBasketball,
  faHippo,
  faAlignJustify,
} from "@fortawesome/free-solid-svg-icons";
import { teams } from "../CreateCardForm/teamslist";
import "font-awesome/css/font-awesome.min.css";
import { useSport } from '../../utils/SportsProvider'
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ForSalePriceAndTemplate from "./ForSalePriceAndTemplate";
import ForTradeTradingTemplate from "./ForTradeTradingTemplate";
import { faLockOpen } from "@fortawesome/free-solid-svg-icons";
import ConditionComponent from "../GridViewMain/ConditionComponent/ConditionComponent";
import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import ImageSelector  from "../../utils/icon/ImageSelector";
import DragDropSelector  from "../../utils/icon/DragDropSelector ";
import  {searchSelectStyles,
  formSelectStyles,
  compactSelectStyles,
  errorSelectStyles} from "../../styles/components/selectStyles.js";
function CreateCardForm({ onStepUpdate }) {
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.CreateCardForm[key][currentLang]; // Adjust the path according to your JSON structure
  
  
  const { userId,liveCsrfToken,isAuthenticated,loading } = useContext(AuthContext);
  const [isInitialized, setIsInitialized] = useState(false); // Track initialization
  const [previewImage, setPreviewImage] = useState(null);
  const [previewImageBack, setPreviewImageBack] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = useSport();        // state.sport = "Hockey" | "Pokemon"
  const sport = state.sport;
  const [selectedType, setSelectedType] = useState(sport);
  const isPokemon = selectedType === "Pokemon";
  const [pokemonSet, setPokemonSet] = useState(null);        // {value:SetId,label:SetName}
const [pokemonCard, setPokemonCard] = useState(null);      // {value: CardId, label: "Name #x/y"}
const [pokemonRarity, setPokemonRarity] = useState(null);  // {value:RarityId,label:RarityName} (optionnel si déjà dans pokemonCards)
const [holoOverride, setHoloOverride] = useState('');
const [pokemonSetInput, setPokemonSetInput] = useState("");
const [pokemonSetOptions, setPokemonSetOptions] = useState([]);
const [pokemonCardInput, setPokemonCardInput] = useState("");
const [pokemonCardOptions, setPokemonCardOptions] = useState([]);
  const [lockedFields, setLockedFields] = useState({});
  const [isFieldsLocked, setIsFieldsLocked] = useState(false);
  const [viewPreview, setViewPreview] = useState(false);
  const [errors, setErrors] = useState({});
     const [shouldAutoSelectVariation, setShouldAutoSelectVariation] = useState(false);
  const [collections, setCollections] = useState([
    { ListId: 0, Title: "NotAssigned", collectionCount: 0,
    value :0,label: "NotAssigned" },
  ]);
  const [allowCreateNewCollection, setAllowCreateNewCollection] =
    useState(false);
  const [selectedCollectionLive, setSelectedCollectionLive] = useState({
    ListId: 0,
    value :0,
    Title: "NotAssigned",
    label: "NotAssigned",
    collectionCount: 0,
  });
  console.log("Location State in CreateCardForm:", location.state);
  const [isFetching, setIsFetching] = useState(false);
  const [newPlayerName, setNewPlayerName] = useState("");
  const [keyTempo, setKeyTempo] = useState("");
  const [selectKey, setSelectKey] = useState(Date.now());
  const userNavigatingRef = useRef(false);
    const markUserNav = () => { userNavigatingRef.current = true; };

const [qsFocused, setQsFocused] = useState(false);

const fileFrontRef = useRef(null);
const fileBackRef  = useRef(null);


const [frontFile, setFrontFile] = useState(null); // if you already have this, reuse yours

// mini util – returns plain base64 (no data:... prefix)
async function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.onload = () => {
      const result = reader.result || '';
      const str = typeof result === 'string' ? result : '';
      // keep only the base64 payload
      const clean = str.includes('base64,') ? str.split('base64,')[1] : str;
      resolve(clean);
    };
    reader.readAsDataURL(file);
  });
}



function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.onload = () => {
      const str = typeof reader.result === "string" ? reader.result : "";
      resolve(str.includes("base64,") ? str.split("base64,")[1] : str);
    };
    reader.readAsDataURL(file);
  });
}

async function scanFrontWithXimilar() {
  try {
    if (!frontFile) {
      console.log("No front file selected.");
      return;
    }
    const b64 = await fileToBase64(frontFile);

    // pick endpoint based on your form’s type (adjust if you store this elsewhere)
    const mode = formData?.Type === "Pokemon" ? "pokemon" : "hockey";

    // keep credits low for testing
    const optsPokemon = { pricing: false, lang: true, rotate: true };
    const optsHockey  = { pricing: false, magic_ai: false };

    const res = mode === "pokemon"
      ? await tcgIdentifyByBase64(b64, optsPokemon)
      : await sportIdentifyByBase64(b64, optsHockey);

    console.log("Ximilar raw response:", res);
  } catch (err) {
    console.error("Ximilar scan error:", err);
  }
}



  // const [renameCollectionTitle, setRenameCollectionTitle] = useState({});
  // const [allowCollectionRename, setAllowCollectionRename] = useState(false)
  // const [
  //   confirmationVisibleRenameWatchList,
  //   setConfirmationVisibleRenameWatchList,
  // ] = useState({});
  const [createNewCollectionTitle, setCreateNewCollectionTitle] = useState("");
  const [
    confirmationVisibleCreateNewCollection,
    setConfirmationVisibleCreateNewCollection,
  ] = useState(false);

   const [setSearchTerm,setSetSearchTerm]= useState('')
  const [openSelect,setOpenSelect]=useState(null); 
  const selectRefs = {
    player: useRef(null),
    team: useRef(null),
    set: useRef(null),
    variationName:useRef(null),
    variation: useRef(null),
  };

const focusNextField = (nextField) => {
  if (!userNavigatingRef.current) return;     // ← don’t auto-focus during bootstrap
  setTimeout(() => {
    if (selectRefs[nextField]?.current) {
      selectRefs[nextField].current.focus();
      selectRefs[nextField].current.onMenuOpen?.();
    }
  }, 80);
};

  const toIntBool = (val) => ['true', true, 1].includes(val) ? 1 : 0;
  /*const teams = {
    0: {'id': 0, 'name': 'TBD', 'abbreviation': 'TBD', 'api': 'TBD'},
    1: {'id': 1, 'name': 'New Jersey Devils', 'abbreviation': 'NJD', 'api': '/api/v1/teams/1'},
    2: {'id': 2, 'name': 'New York Islanders', 'abbreviation': 'NYI', 'api': '/api/v1/teams/2'},
    3: {'id': 3, 'name': 'New York Rangers', 'abbreviation': 'NYR', 'api': '/api/v1/teams/3'},
    4: {'id': 4, 'name': 'Philadelphia Flyers', 'abbreviation': 'PHI', 'api': '/api/v1/teams/4'},
    5: {'id': 5, 'name': 'Pittsburgh Penguins', 'abbreviation': 'PIT', 'api': '/api/v1/teams/5'},
    6: {'id': 6, 'name': 'Boston Bruins', 'abbreviation': 'BOS', 'api': '/api/v1/teams/6'},
    7: {'id': 7, 'name': 'Buffalo Sabres', 'abbreviation': 'BUF', 'api': '/api/v1/teams/7'},
    8: {'id': 8, 'name': 'Montréal Canadiens', 'abbreviation': 'MTL', 'api': '/api/v1/teams/8'},
    9: {'id': 9, 'name': 'Ottawa Senators', 'abbreviation': 'OTT', 'api': '/api/v1/teams/9'},
    10: {'id': 10, 'name': 'Toronto Maple Leafs', 'abbreviation': 'TOR', 'api': '/api/v1/teams/10'},
    12: {'id': 12, 'name': 'Carolina Hurricanes', 'abbreviation': 'CAR', 'api': '/api/v1/teams/12'},
    13: {'id': 13, 'name': 'Florida Panthers', 'abbreviation': 'FLA', 'api': '/api/v1/teams/13'},
    14: {'id': 14, 'name': 'Tampa Bay Lightning', 'abbreviation': 'TBL', 'api': '/api/v1/teams/14'},
    15: {'id': 15, 'name': 'Washington Capitals', 'abbreviation': 'WSH', 'api': '/api/v1/teams/15'},
    16: {'id': 16, 'name': 'Chicago Blackhawks', 'abbreviation': 'CHI', 'api': '/api/v1/teams/16'},
    17: {'id': 17, 'name': 'Detroit Red Wings', 'abbreviation': 'DET', 'api': '/api/v1/teams/17'},
    18: {'id': 18, 'name': 'Nashville Predators', 'abbreviation': 'NSH', 'api': '/api/v1/teams/18'},
    19: {'id': 19, 'name': 'St. Louis Blues', 'abbreviation': 'STL', 'api': '/api/v1/teams/19'},
    20: {'id': 20, 'name': 'Calgary Flames', 'abbreviation': 'CGY', 'api': '/api/v1/teams/20'},
    21: {'id': 21, 'name': 'Colorado Avalanche', 'abbreviation': 'COL', 'api': '/api/v1/teams/21'},
    22: {'id': 22, 'name': 'Edmonton Oilers', 'abbreviation': 'EDM', 'api': '/api/v1/teams/22'},
    23: {'id': 23, 'name': 'Vancouver Canucks', 'abbreviation': 'VAN', 'api': '/api/v1/teams/23'},
    24: {'id': 24, 'name': 'Anaheim Ducks', 'abbreviation': 'ANA', 'api': '/api/v1/teams/24'},
    25: {'id': 25, 'name': 'Dallas Stars', 'abbreviation': 'DAL', 'api': '/api/v1/teams/25'},
    26: {'id': 26, 'name': 'Los Angeles Kings', 'abbreviation': 'LAK', 'api': '/api/v1/teams/26'},
    28: {'id': 28, 'name': 'San Jose Sharks', 'abbreviation': 'SJS', 'api': '/api/v1/teams/28'},
    29: {'id': 29, 'name': 'Columbus Blue Jackets', 'abbreviation': 'CBJ', 'api': '/api/v1/teams/29'},
    30: {'id': 30, 'name': 'Minnesota Wild', 'abbreviation': 'MIN', 'api': '/api/v1/teams/30'},
    52: {'id': 52, 'name': 'Winnipeg Jets', 'abbreviation': 'WPG', 'api': '/api/v1/teams/52'},
    53: {'id': 53, 'name': 'Arizona Coyotes', 'abbreviation': 'ARI', 'api': '/api/v1/teams/53'},
    54: {'id': 54, 'name': 'Vegas Golden Knights', 'abbreviation': 'VGK', 'api': '/api/v1/teams/54'},
    55: {'id': 55, 'name': 'Seattle Kraken', 'abbreviation': 'SEA', 'api': '/api/v1/teams/55'},
    27: {'id': 27, 'name': 'Hartford Whalers', 'abbreviation': 'HFD', 'api': 'TBD'},
    31: {'id': 31, 'name': 'Atlanta Thrashers', 'abbreviation': 'ATL', 'api': 'TBD'},
    32: {'id': 32, 'name': 'Quebec Nordiques', 'abbreviation': 'QUE', 'api': 'TBD'},
    }
    */
  // const updateError = (fieldName, message) => {
  //   setErrors((prevErrors) => ({
  //     ...prevErrors,
  //     [fieldName]: message,
  //   }));
  // };

  // const clearError = (fieldName) => {
  //   setErrors((prevErrors) => {
  //     const updatedErrors = { ...prevErrors };
  //     delete updatedErrors[fieldName];
  //     return updatedErrors;
  //   });
  // }
  // State variables for the form data and various messages

useEffect(() => {
  if (userId === null || !isAuthenticated) {

    navigate(i18n.language === 'fr' ? '/fr/login' : '/login');
  }
}, [userId, loading, i18n.language]);




  const [formData, setFormData] = useState({
    PlayerId: 0,
    Name: newPlayerName,
    Type: "Hockey",
    cardName: "",
    YearMade: "",
    IsRookie: false,
    IsPatch: false,
    IsAuto: false,
    IsJersey: false,
    Variation: "",
    Numbered: "",
    Uniform: 0,
    Sets: "",
    SetName: "",
    InsertFamilyId:"",
    SpecialAttribute: "",
    Image: "",
    ImageBack: "",
    NumberBehind: "",
    Graded: false,
    GradeCompany: "",
    Grade: 0.0,
    playerNotFound: false,
    NotFoundPlayerInput: "",
    isPC: false,
    isForSale: false,
    isForTrade: false,
    isOnEbay: false,
    ConditionCard: "NM",
    EstimateValue: "0",
    PaidPrice: "0",
    Location: "",
    SalePrice: "",
    ShippingTemplate: "",
    Shipping: "",
    TradingTemplate: "",
    TradeValue: "",
    BestOffer: false,
    SeeMore:false,
  });



  let disableConditionSelect =
    formData?.Graded === "Graded" || formData?.Graded === true;

const mapPokemonCardDataToFormDataFromSearch = (card) => {
  console.log('pokemon cardData Cardsearch', card);

  setPreviewImage(card.Image || "");
  setPreviewImageBack("");

  setPokemonSet({
    value: card.SetId,
    label: card.SetName,
  });

  setPokemonCard({
    value: card.CardId,
    label: `${card.CardName}${card.NumberInSet ? ` #${card.NumberInSet}` : ""}${card.Rarity ? ` · ${card.Rarity}` : ""}`,
    rarity: card.Rarity || null,
    rarityId: card.RarityId || null,
    image: card.ImageFront || null,
    setId: card.SetId,
    number: card.NumberInSet || null,
  });

  setPokemonRarity(
    card.RarityId
      ? { value: card.RarityId, label: card.Rarity || "" }
      : null
  );

  setHoloOverride(card.HoloOverride || "");
  handleInputChange2(card.SearchTitle, false);

  return {
    cardId: card.CardId,
    Type: "Pokemon",

    // on garde une structure compatible avec le reste du form
    PlayerId: 0,
    Name: card.CardName || "",
    RookieYear: 0,
    cardName: card.CardName || "",
    YearMade: 0,

    IsRookie: false,
    IsPatch: false,
    IsAuto: false,
    IsJersey: false,

    Variation: "",
    Numbered: "",
    Uniform: 0,

    Sets: card.SetId || "",
    SetName: card.SetName || "",
    InsertFamilyId: "",

    Image: card.ImageFront || "",
    ImageBack: "",
    NumberBehind: card.NumberInSet || "",

    SpecialAttribute: "",
    Graded: false,
    GradeCompany: "",
    Grade: 0.0,

    isPC: 0,
    isForSale: 0,
    isForTrade: 0,
    isOnEbay: 0,

    ConditionCard: card.ConditionCard || "NM",
    EstimateValue: card.PriceMarket || 0,
    EstimateAVG: card.PriceMid || 0,
    PaidPrice: 0,
    Location: "",
    SalePrice: 0,
    BestOffer: 0,
    ShippingTemplate: 0,
    Shipping: 0,
    TradingTemplate: 0,
    TradeValue: 0,
    SeeMore: false,
  };
};
  const mapCardDataToFormDataFromSearch = (card) => {
    console.log('cardData Cardsearch',card)
    setPreviewImageBack(card.ImageBack);
    setPreviewImage(card.Image);
    setRookieYearForThisPlayer(card.RookieYear);
    setNewPlayerName({value: card.PlayerId,label: card.Name,});
    setSetsCurrentlySelected({
      value: card.setId,
      label: card.SetName,
      Set: card.TypeSet,
      InsertFamilyId: card.InsertFamilyId
    });
    setUniformCurrentlySelected({
      value: card.TeamsId,
      label: FindTheTeamNameById(card.TeamsId),
    });
    setNewPlayerName({
      value: card.PlayerId,
      label: card.Name,
      rookieYear: card.RookieYear,
    });

    setNewVariationName({
      value: card.IdCardVariation,
      label: card.cardName,
      name: card.fromSet,
      InsertFamilyId: card.InsertFamilyId,
    });

    setNewVariation({
      value: card.IDVariation,
      label: card.variationName,
      name: card.IdCardVariation,
    });
    setNewVariationNameId(card.IdCardVariation);

    handleInputChange2(card.SearchTitle, false);

    // return {
    //   cardId: card.CardId,
    //   PlayerId: card.PlayerId,
    //   Name: card.Name,
    //   RookieYear: card.RookieYear,
    //   Type: card.Type,
    //   //CardName: card.CardName || "",
    //   cardName: card.cardName || "",
    //   YearMade: card.YearMade || 0,
    //   IsRookie: card.IsRookie === "Rookie(RC)" ? 1 : 0,
    //   IsPatch: card.IsPatch === "Patch" ? 1 : 0,
    //   IsAuto: card.IsAuto === "Auto" ? 1 : 0,
    //   IsJersey: card.IsJersey === "Jersey" ? 1 : 0,
    //   IsTribute: card.IsTribute,
    //   Variation: card.IDVariation || "",
    //   Numbered: card.numbered || "",
    //   Uniform: FindTheTeamNameById(card.TeamsId) || "",
    //   Sets: card.setId || "",
    //   SetName: card.SetName || "",
    //   Image: card.Image || "",
    //   ImageBack: card.ImageBack || "",
    //   NumberBehind: card.NumberBehind || "",
    //   playerNotFound: false,
    //   NotFoundPlayerInput: "",
    //   SpecialAttribute: "",
    //   isPC: 0,
    //   isForSale: 0,
    //   isForTrade: 0,
    //   isOnEbay: 0,
    //   ConditionCard: card.ConditionCard || "",
    //   EstimateValue: card.EstimateValue || 0,
    //   EstimateAVG: card.EstimateAVG || 0,
    //   PaidPrice: card.PaidPrice || 0,
    //   Location: card.Location || "",
    //   SalePrice: card.Price || 0,
    //   BestOffer: card.BestOffer || 0,
    //   ShippingTemplate: card.ShippingTemplate || 0,
    //   Shipping: card.Shipping || 0,
    //   TradingTemplate: card.TradingTemplate || 0,
    //   TradeValue: card.TradeValue || 0,
    //   SeeMore:false,
    // };
    console.log('juste avant le setformData 256')


    //setPreviewImage(card.Image)
    //setPreviewImageBack(card.ImageBack)
    // setFormData((prevData) => ({
    //   ...prevData,
    return {
      cardId: card.CardId,  // Ensure cardId is set
      PlayerId: card.PlayerId,
      Name: card.Name,
      RookieYear: card.RookieYear,
      Type: card.Type,
      cardName: card.cardName || "",
      YearMade: card.YearMade || 0,
      IsRookie: card.IsRookie === "Rookie(RC)" ? true : false,
      IsPatch: card.IsPatch === "Patch" ? true : false,
      IsAuto: card.IsAuto === "Auto" ? true : false,
      IsJersey: card.IsJersey === "Jersey" ? true : false,
 
      Variation: card.IDVariation || "",
      Numbered: card.numbered || "",
      Uniform: FindTheTeamNameById(card.TeamsId) || "",
      Sets: card.setId || "",
      SetName: card.SetName || "",
      InsertFamilyId:card.InsertFamilyId|| "",
      Image: card.Image || "",
      ImageBack: card.ImageBack || "",
      NumberBehind: card.NumberBehind || "",
      isPC: 0,
      isForSale: 0,
      isForTrade: 0,
      isOnEbay: 0,
      ConditionCard: card.ConditionCard || "NM",
      EstimateValue: card.EstimateValue || 0,
      EstimateAVG: card.EstimateAVG || 0,
      PaidPrice: card.PaidPrice || 0,
      Location: card.Location || "",
      SalePrice: card.Price || 0,
      BestOffer: card.BestOffer || 0,
      ShippingTemplate: card.ShippingTemplate || 0,
      Shipping: card.Shipping || 0,
      TradingTemplate: card.TradingTemplate || 0,
      TradeValue: card.TradeValue || 0,
      SeeMore: false,
      Graded: false,
      GradeCompany: "",
      Grade: 0.0,
    }
    

  };

  const resetFormData = () => {
    console.log('je suis formData')
    const initialFormData2 = {
      PlayerId: 0,
      Type: "Hockey",
      cardName: "",
      YearMade: "",
      IsRookie: false,
      IsPatch: false,
      IsAuto: false,
      IsJersey: false,
      InsertFamilyId: "",
      Variation: "",
      Numbered: "",
      Uniform: 0,
      Sets: "",
      SpecialAttribute: "",
      Image: "",
      ImageBack: "",
      NumberBehind: "",
      Graded: false,
      GradeCompany: "",
      Grade: 0.0,
      playerNotFound: false,
      NotFoundPlayerInput: "",
      isPC: false,
      isForSale: false,
      isForTrade: false,
      isOnEbay: false,
      ConditionCard: "NM",
      EstimateValue: "0",
      PaidPrice: "0",
      Location: "",
      SalePrice: "",
      ShippingTemplate: "",
      Shipping: "",
      TradingTemplate: "",
      TradeValue: "",
      BestOffer: false,
      SeeMore:false,
    };
    console.log("lockedFields ", lockedFields);

    function generateInitialFormData(lockedFields, formData) {
      console.log("lockedFields : ", lockedFields, "formData ", formData);
      setUniformListForThisPlayer("");
      setUniformCurrentlySelected("");
      return {
        PlayerId: lockedFields.PlayerId ? formData.PlayerId : 0,
        Type: "Hockey",
        cardName: "",
        YearMade: lockedFields.Sets
          ? getYearFromSet(setsCurrentlySelected.label.toString())
          : null,
        IsRookie: false,
        IsPatch: false,
        IsAuto: false,
        IsJersey: false,
       
        Variation: "",
        Numbered: "",
        Uniform: lockedFields.PlayerId ? uniformCurrentlySelected.value : null,
        Sets: lockedFields.Sets ? setsCurrentlySelected.value : null,
        SpecialAttribute: "",
        Image: "",
        ImageBack: "",
        NumberBehind: lockedFields.NumberBehind ? formData.NumberBehind : "",
        Graded: false,
        GradeCompany: "",
        Grade: 0.0,
        playerNotFound: false,
        NotFoundPlayerInput: "",
        isPC:
          lockedFields.Attributes && lockedFields.Attributes[0]
            ? formData.isPC
            : false,
        isForSale: false,
        isForTrade: false,
        isOnEbay:
          lockedFields.Attributes && lockedFields.Attributes[3]
            ? formData.isOnEbay
            : false,
        ConditionCard: "NM",
        EstimateValue: "0",
        PaidPrice: "0",
        Location: lockedFields.Location ? formData.Location : "",
        SalePrice: "",
        ShippingTemplate: "",
        Shipping: "",
        TradingTemplate: "",
        TradeValue: "",
        BestOffer: false,
        SeeMore:false,
      };
    }



    const initialFormData = generateInitialFormData(lockedFields, formData);

    //DOit faire un && : ? pour la config une fois reset

    
    let playerIsLocked = false;
    let setsNeedsToBeReset = true;
    let cardNameNeedsToBeReset = true;
    for (const field in lockedFields) {
      console.log("field ", field);
      if (field === "Attributes") {
        initialFormData["isPC"] = lockedFields[field][0];
        initialFormData["isForSale"] = lockedFields[field][1];
        initialFormData["isForTrade"] = lockedFields[field][2];
        initialFormData["isOnEbay"] = lockedFields[field][3];
        console.log("doing attributs");
      } else if (field === "newVariation") {
        setNewVariation(lockedFields[field]);
      } else if (field === "newVariationName") {
        if ("newVariation" in lockedFields) {
          setNewVariationName(lockedFields[field]);
          cardNameNeedsToBeReset = false;
          initialFormData["IsRookie"] = formData.IsRookie === 1 ? true : false;
          initialFormData["IsPatch"] = formData.IsPatch === 1 ? true : false;
          initialFormData["IsAuto"] = formData.IsAuto === 1 ? true : false;
          initialFormData["IsJersey"] = formData.IsJersey === 1 ? true : false;
        
        }
      } else if (field === "Sets") {
        initialFormData["Sets"] = setsCurrentlySelected.value;
        setsNeedsToBeReset = false;
      } else if (field === "PlayerId") {
        playerIsLocked = true;
        initialFormData["PlayerId"] = lockedFields["PlayerId"];
      } else if (
        field === "Location" &&
        lockedFields["LocationPlus1"] === true
      ) {
        const newLocation = incrementLocationOrCardNumber(lockedFields[field]);
        console.log(lockedFields[field], " new:", newLocation);

        lockedFields["Location"] = newLocation;
      } else if (field === "LocationPlus1") {
        console.log("On tente un LocationPlus1");
        console.log(lockedFields);
      } else {
        initialFormData[field] = lockedFields[field];
      }

      if (field === "Location") {
        console.log("on est dans location");
        console.log(
          "initial ",
          initialFormData["Location"],
          " locked ",
          lockedFields[field]
        );
      }
    }

    console.log("initialFormData ", initialFormData);
    console.log("lockedFields ", lockedFields);
    setFormData(initialFormData);
    if (setsNeedsToBeReset) {
      console.log("on essaie de reset ca 205");
      setSetsCurrentlySelected({
        value: "",
        label: "",
        Set: "",
        InsertFamilyId:""
      });
    }
    if (cardNameNeedsToBeReset) {
      setNewVariationName("");
      setNewVariation("");
      setLockedFields((prevLockedFields) => {
        const updatedLockedFields = { ...prevLockedFields };
        delete updatedLockedFields.newVariation;
        return updatedLockedFields;
      });
    }

    if (playerIsLocked === false) {
      setNewPlayerName(null);
      setRookieYearForThisPlayer(0);
    }

    setThisIsANewVariation(false);
    setThisIsANewPlayer(false);
    setThisIsANewVariationName(false);
    const location = handleIncrementLocation();
  };

  const toggleFieldLock = (field) => {
    if (field in lockedFields) {
      // Field is already locked, so remove it
      const { [field]: removedField, ...restLockedFields } = lockedFields;
      setLockedFields(restLockedFields);
    } else if (field === "Attributes") {
      const currentAttributs = [
        formData.isPC,
        formData.isForSale,
        formData.isForTrade,
        formData.isOnEbay,
      ];
      console.log("currentAttributs ", currentAttributs);
      setLockedFields((prevLockedFields) => ({
        ...prevLockedFields,
        [field]: currentAttributs,
      }));
    } else if (field === "newVariationName") {
      setLockedFields((prevLockedFields) => ({
        ...prevLockedFields,
        [field]: newVariationName,
      }));
    } else if (field === "newVariation") {
      setLockedFields((prevLockedFields) => ({
        ...prevLockedFields,
        [field]: newVariation,
      }));
    } else if (field === "LocationPlus1") {
      setLockedFields((prevLockedFields) => ({
        ...prevLockedFields,
        [field]: true,
      }));
      console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA cest ok");
    } else {
      // Field is not locked, so add it
      setLockedFields((prevLockedFields) => ({
        ...prevLockedFields,
        [field]: formData[field],
      }));
    }
  };

  const updateLockedFields = () => {
    const updatedLockedFields = { ...lockedFields };

    if ("Type" in updatedLockedFields) {
      updatedLockedFields.Type = selectedType;
    }

    if ("PlayerId" in updatedLockedFields) {
      updatedLockedFields.PlayerId = formData.PlayerId;
    }

    if ("Sets" in updatedLockedFields) {
      updatedLockedFields.Sets = setsCurrentlySelected
        ? setsCurrentlySelected.value
        : "";
    }

    if ("YearMade" in updatedLockedFields) {
      updatedLockedFields.YearMade = formData.YearMade;
    }

    if ("cardName" in updatedLockedFields) {
      updatedLockedFields.cardName = newVariationName;
    }

    if ("Variation" in updatedLockedFields) {
      updatedLockedFields.Variation = newVariation;
    }
    if ("Attributes" in updatedLockedFields) {
      updatedLockedFields.Attributes[0] = formData.isPC;
      updatedLockedFields.Attributes[1] = formData.isForSale;
      updatedLockedFields.Attributes[2] = formData.isForTrade;
      updatedLockedFields.Attributes[3] = formData.isOnEbay;
    }

    setLockedFields(updatedLockedFields);
  };

  useEffect(() => {
    console.log("lockedfield ", lockedFields, "is it locked ", isFieldsLocked);
    console.log("formData ", formData);
    console.log("PlayerId" in lockedFields);
  }, [lockedFields]);

  useEffect(() => {
    console.log("selectedCollectionLive", selectedCollectionLive);
  }, [selectedCollectionLive]);

  const isFieldLocked = (field) => {
    return isFieldsLocked && field in lockedFields;
  };

  const saveTheLockedValues = () => {
    if (isFieldsLocked) {
      setFormData((prevFormData) => {
        const updatedFormData = { ...prevFormData };
        for (const field in lockedFields) {
          updatedFormData[field] = lockedFields[field];
        }
        return updatedFormData; // Update the formData with locked field values
      });
    }
    resetFormData();
  };

  const [lockedAttributes, setLockedAttributes] = useState({});
  const attributes = ["isPc", "isForSale", "isForTrade", "isOnEbay"];
  const toggleAttributeLock = (attribute) => {
    setLockedAttributes((prevAttributes) => ({
      ...prevAttributes,
      [attribute]: !prevAttributes[attribute],
    }));
  };

  const saveLockedAttributes = () => {
    // Iterate over the attributes and save their values if they are locked
    const savedValues = {};
    attributes.forEach((attribute) => {
      if (lockedAttributes[attribute]) {
        savedValues[attribute] = formData[attribute];
      }
    });
  };
  const [newPlayer, setNewPlayer] = useState({
    Type: "",
    PlayerName: "",
  });
  const [rookieYearForThisPlayer, setRookieYearForThisPlayer] = useState(0);
  const [playerOptions, setPlayerOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [playerNameTempo, setPlayerNameTempo] = useState("");
  const [variation, setVariation] = useState([]);
  
  const [cardVariation, setCardVariation] = useState([]);
  const [filteredVariation, setFilteredVariation] = useState("");
  const [liveSelectedVariation, setLiveSelectedVariation] = useState([]);
  const [liveSelectedCardName, setLiveSelectedCardName] = useState([]);
  // State variables for dropdown options
  const [options, setOptions] = useState([]);
  const [setsSelected, setSetsSelected] = useState([]);
  const [setsCurrentlySelected, setSetsCurrentlySelected] = useState({});

  const [uniformCurrentlySelected, setUniformCurrentlySelected] = useState({});
  const [uniformListForThisPlayer, setUniformListForThisPlayer] = useState([]);
  const [filteredSets, setFilteredSets] = useState([]);
  const [thisIsANewPlayer, setThisIsANewPlayer] = useState(false);

  const [thisIsANewVariation, setThisIsANewVariation] = useState(false);
  const [thisIsANewVariationName, setThisIsANewVariationName] = useState(false);
  const [newVariationName, setNewVariationName] = useState("");
  const [newVariation, setNewVariation] = useState("");
  const [newVariationNameId, setNewVariationNameId] = useState(0);
  const [showGrading, setShowGrading] = useState(false);
  const [testisLoading, setTestIsLoading] = useState(false);
  const [testoptions, setTestOptions] = useState([]);
  const [variationLocked, setVariationLocked] = useState(true);

  const [IsSuggestionOpen, setIsSuggestionOpen] = useState(false);
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [currentSuggestions, setCurrentSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  /*################### double slider ######################*/
  const [range, setRange] = useState([1, 10]);

  let fetchTimeout;

  const removeImage = (key) => {
  setFormData(prev => ({ ...prev, [key]: "" }));
  if (key === "Image") setPreviewImage("");      // if you keep a separate preview state
  if (key === "ImageBack") setPreviewImageBack("");
};
    useEffect(() => {
if (onStepUpdate) {
  onStepUpdate(
    isPokemon
      ? {
          Type: !!formData.Type,
          Player: true,                 // (ou remplace par Species=true)
          Set: !!pokemonSet?.value,
          Card: !!pokemonCard?.value,
          Variation: true,              // no-op en Pokemon
          Image: !!formData.Image
        }
      : {
          Type: !!formData.Type,
          Player: !!newPlayerName?.label,
          Set: !!formData.Sets,
          Card: !!formData.cardName,
          Variation: !!newVariation,
          Image: !!formData.Image
        }
  );
}
}, [formData, newPlayerName,newVariation])

  const normalizeInput = (input) => {
    return input
      .trim()
      .toLowerCase()
      .normalize("NFD") // Breaks accented characters into base + accent
      .replace(/[\u0300-\u036f]/g, ""); // Removes accents
  };
const resetHockeyFields = () => {
  setNewPlayerName("");
  setRookieYearForThisPlayer(0);
  setSetsCurrentlySelected({});
  setUniformCurrentlySelected({});
  setUniformListForThisPlayer([]);
  setNewVariationName("");
  setNewVariation("");
  setNewVariationNameId(0);
  setVariation([]);
  setFilteredVariation("");
  setSetSearchTerm("");
};

const resetPokemonFields = () => {
  setPokemonSet(null);
  setPokemonCard(null);
  setPokemonRarity(null);
  setHoloOverride("");
  setPokemonSetInput("");
  setPokemonCardInput("");
  setPokemonSetOptions([]);
  setPokemonCardOptions([]);
};

useEffect(() => {
  const fetchAndSetCardData = async () => {
    try {
      const incomingCard = location.state?.card;
      if (!incomingCard || isInitialized) return;

      const inferredType =
        incomingCard.CatalogType === "Pokemon" || incomingCard.Type === "Pokemon"
          ? "Pokemon"
          : "Hockey";

      // force le bon mode dès le départ
      setSelectedType(inferredType);

      // identifiant à utiliser pour aller chercher la base catalog
      const lookupId =
        inferredType === "Pokemon"
          ? (incomingCard.PokemonCardId || incomingCard.CardId || incomingCard.cardId)
          : (incomingCard.CardId || incomingCard.cardId);

      if (!lookupId) {
        console.warn("No lookup id found in location.state.card");
        return;
      }

      const endpoint =
        inferredType === "Pokemon"
          ? `${process.env.REACT_APP_API_BASE}/api/searchbar/getPokemonDataFromCardId/${lookupId}`
          : `${process.env.REACT_APP_API_BASE}/api/searchbar/getDataFromCardId/${lookupId}`;

      const { data } = await axios.get(endpoint, { withCredentials: true });

      if (!data || data.length === 0) {
        console.warn("No results found for add yours");
        return;
      }

      const mapped =
        inferredType === "Pokemon"
          ? mapPokemonCardDataToFormDataFromSearch(data[0])
          : mapCardDataToFormDataFromSearch(data[0]);

      if (inferredType !== "Pokemon") {
        if (mapped?.Name) {
          handlePlayerInputChange(mapped.Name, true);
        }
        if (mapped?.SetName) {
          handleSetInputChange(mapped.SetName);
          setSetSearchTerm(mapped.SetName);
        }
        if (mapped?.cardName) {
          handleCardInputChange(mapped.cardName);
          setShouldAutoSelectVariation(true);
        }
      }

      setFormData(mapped);
      setIsInitialized(true);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  fetchAndSetCardData();
}, [location.state, isInitialized]);
  useEffect(() => {
    if (
      searchSuggestions.length > 0 &&
      searchSuggestions !== currentSuggestions
    ) {
      console.log("suggestion should be there", searchSuggestions);
      setCurrentSuggestions(searchSuggestions);
      setIsSuggestionOpen(true);
    } else {
      setIsSuggestionOpen(false);
      setCurrentSuggestions([]);
    }
  }, [searchSuggestions]);

  useEffect(() => {
    if (
      searchSuggestions.length > 0 &&
      searchSuggestions === currentSuggestions
    ) {
      console.log("currentSuggestions should be there", currentSuggestions);
      // setForceRerender((prev) => !prev);
    }
  }, [currentSuggestions]);

  const fetchSuggestions2 = async (inputValue) => {
    setIsFetching(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/searchbar/DeepSearch?searchTerm=${encodeURIComponent(inputValue)}&type=${encodeURIComponent(selectedType)}`,
      {
        withCredentials: true, // ✅ sends cookies/session
      }
      );

      const suggestions = mapResponseToOptions(response.data, "DeepSearch");
      console.log("0000 suggestion", suggestions);

      return suggestions || []; // Return the array of suggestions or an empty array
    } catch (error) {
      console.error("Error fetching suggestions: v2", error);
      setSearchSuggestions([]);
      return []; // Return an empty array in case of an error
    } finally {
      setIsFetching(false);
    }
  };

  const handleInputChange2 = (inputValue, validSearch) => {
    setInputValue(inputValue);
    console.log('je trigger inputchange inputValue, validSearch',inputValue, validSearch)
    // Split the input value into words using spaces as separators
    // Check if the last word is at least 3 characters long
    if ( validSearch != false) {

      if(inputValue.length >= 4)
      {
      // Split the input value into words using spaces as separators
      const words = inputValue.split(" ");
      // Get the last word entered by the user
      const lastWord = words[words.length - 1];

      if (lastWord.length >= 3) {
        clearTimeout(fetchTimeout);

        // Set a new timeout to fetch suggestions after a short delay
        fetchTimeout = setTimeout(() => {
          fetchSuggestions2(inputValue)
            .then((suggestions) => {
              setSearchSuggestions(suggestions);
            })
            .catch((error) => {
              console.error("Error handling input change:", error);
              setSearchSuggestions([]);
            });
        }, 300); // Adjust the delay (in milliseconds) as needed
      } else {
        // Clear suggestions if the input is less than 3 characters
        setSearchSuggestions([]);
        setIsSuggestionOpen(false);
      }
    } else {
      setCurrentSuggestions([]);
      setIsSuggestionOpen(false);
    }}
    else {
      setCurrentSuggestions([]);
      setIsSuggestionOpen(false);
    }
  };


  const handleSearch2 = async (selectedOption) => {
    try {
      console.log("selectedOption 214", selectedOption);
      if (selectedOption) {
        if (selectedOption.value > 0 && selectedOption.value !== "") {
          const getResultFromSelectedSuggestion = await handleGetMatchingResult(
            selectedOption.value
          );
          setCurrentSuggestions([selectedOption]); // Ensure this is an array
          console.log(
            `Search results for ${selectedOption.value}:`,
            getResultFromSelectedSuggestion
          );
          if (getResultFromSelectedSuggestion.length > 0) {
            console.log("je suis ici 576", getResultFromSelectedSuggestion);

          const dataFromCardId =
  selectedType === "Pokemon"
    ? mapPokemonCardDataToFormDataFromSearch(getResultFromSelectedSuggestion[0])
    : mapCardDataToFormDataFromSearch(getResultFromSelectedSuggestion[0]);

const newCard = dataFromCardId;

setPokemonSetInput(newCard.SetName);

setPokemonCardInput({ value: newCard.cardId, label: newCard.cardName });
if (selectedType !== "Pokemon") {
  if (newCard?.Name) {
    handlePlayerInputChange(newCard.Name, true);
  }
  if (newCard?.SetName) {
    handleSetInputChange(newCard.SetName);
    setSetSearchTerm(newCard.SetName);
  }
  if (newCard?.cardName) {
    handleCardInputChange(newCard.cardName);
    setShouldAutoSelectVariation(true);
  }
}


 setPreviewImage(newCard.Image);
            // // Update formData with the mapped data
             setFormData(dataFromCardId);
  
          }
          setIsSuggestionOpen(false);
        }
      } else {
        setSearchSuggestions([]);
        setCurrentSuggestions([]); // Ensure this is cleared to an empty array
        setIsSuggestionOpen(false);
      }
    } catch (error) {
      console.error("Error handling input change:", error);
    }
  };

const handleGetMatchingResult = async (cardId, forcedType = selectedType) => {
  if (cardId == null) return [];

  try {
    const endpoint =
      forcedType === "Pokemon"
        ? `${process.env.REACT_APP_API_BASE}/api/searchbar/getPokemonDataFromCardId/${cardId}`
        : `${process.env.REACT_APP_API_BASE}/api/searchbar/getDataFromCardId/${cardId}`;

    const response = await axios.get(endpoint, {
      withCredentials: true,
    });

    return response.data || [];
  } catch (error) {
    console.error(`Error fetching ${forcedType} search results:`, error);
    return [];
  }
};

  function ApplyPatch(label) {
    // Split the label by " - ", but preserve years like 2018-19
    const parts = label.split(" - ").filter((part) => !/^\d{4}-\d{2}$/.test(part));
    // Ensure at least 4 parts before taking patches
    if (parts.length > 4) {
      const patches = parts.slice(3);      
      return (
        <div className="card-isfor">
          {patches.map((patch, index) => (
            <div key={index} className="pill">
              {patch}
            </div>
          ))}
        </div>
      );
    }
    return null; // Return null if there are no patches to display
  }
  // function ApplyPatch(label) {
  //   const parts = label.split(" - ");
  //   if (parts.length > 4) {
  //     const patches = parts.slice(4);
  //     return (
  //       <div className="Searchcardisfor flex-h">
  //         {patches.map((patch, index) => (
  //           <div
  //             key={index}
  //             className="Searchpatch"
  //             style={{ marginTop: "15px" }}
  //           >
  //             <p style={{ fontSize: "15px" }}>{patch}</p>
  //           </div>
  //         ))}
  //       </div>
  //     );
  //   }
  //   return null; // Return null if there are no patches to display
  // }

// Trigger re-render only if options change significantly
useEffect(() => {
  if(newPlayerName.length===3&&newPlayerName[1]===' '){
  setSelectKey(Date.now());} // Set a new key to force re-render
}, [options]);


  const fetchSuggestions = async (inputValue, typeT) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/searchbar/custom/${typeT}?searchTerm=${inputValue}`
      ,
      {
        withCredentials: true, // ✅ sends cookies/session
      });
  
      const suggestions = mapResponseToOptions(response.data, typeT);
  
      // Use switch statement to handle different state setters
      switch (typeT) {
        case "player":     
         setOptions(suggestions); // Set options for player
          break;
        case "card":
          const filteredSuggestions = suggestions.filter((item) => {
  // Always exclude if InsertFamilyId is empty or null
  if (!item.InsertFamilyId) return false;

  // If the variation name includes 'Base', check for matching InsertFamilyId
  if (item.label?.toLowerCase().includes('base')) {
    return item.InsertFamilyId === setsCurrentlySelected?.InsertFamilyId;
  }
  // Otherwise, include the item
  return true;
});
setVariation(filteredSuggestions);
          break;
          
        case "set":
          setFilteredSets(suggestions); // Set options for sets
          break;
        default:
          console.error("Unknown typeT:", typeT);
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const mapResponseToOptions = (data, typeT) => {
    return data.map((item) => {
      console.log("item", item);
      switch (typeT) {
        case "player":
          return {
            value: item.PlayerId,
            label: item.Name,
            rookieYear: item.RookieYear,
            rookieTeam: item.TeamId,
          };
        case "set":
          return { value: item.setId, label: item.SetName,InsertFamilyId:item.InsertFamilyId };
        case "card":
          return { value: item.IdCardVariation, label: item.cardName,InsertFamilyId:item.InsertFamilyId };
        case "variation":
          return { value: item.IDVariation, label: item.variationName };
        case "DeepSearch":
          console.log("item 48", item);
          console.log("item 4 v2", item.CardId, item.SearchTitle, item.Image);
          
          return {
            value: item.CardId,
            label: item.SearchTitle,
            Image: item.Image,
          };
      }
    });
  };

  const handlePlayerInputChange = useCallback(
    debounce((inputValue,skipSetPlayerName) => {
      if (inputValue.length >= 3) {
        if (!skipSetPlayerName) {
          setNewPlayerName(inputValue);
        }
        fetchSuggestions(inputValue, "player");
      }
    }, 300),
    []
  );
  const handleSetInputChange = useCallback(
    debounce((inputValue) => {
      if (inputValue.length >= 3) {
        adapteSetbyFilteredType(inputValue);
      }
      // ❌ Don't clear the filteredSets here
    }, 300),
    []
  );
  
  // ✅ Debounce the card input change function
  const handleCardInputChange = useCallback(
    debounce((inputValue) => {
      if (inputValue.length >= 3) {
        fetchSuggestions(inputValue, "card");
      } 

    }, 300), []
  );
  const handleSearch = async (selectedOption) => {
    // Perform search based on the selected type and option
    console.log("selectedOption", selectedOption);
    // if (selectedOption && selectedType) {
    //   try {
    //     console.log(`Searching for ${selectedType}:`, selectedOption.value);
    //     const response = await axios.get(
    //       `${process.env.REACT_APP_API_BASE}/api/searchbar/${selectedType}?searchTerm=${selectedOption.label}`
    //     );
    //     console.log(`Search results for ${selectedType}:`, response.data);
    //     // Add logic to handle and display the search results
    //   } catch (error) {
    //     console.error(`Error fetching ${selectedType} search results:`, error);
    //   }
    // }
  };

  const fetchData = async () => {
    // const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/players`);
    // const players = response.data.map((player) => ({
    //   value: player.PlayerId,
    //   label: player.Name,
    //   rookieYear: player.RookieYear,
    //   rookieTeam: player.TeamId,
    // }));
    // setOptions(players);
    setFormData((prevData) => ({
      ...prevData,
      Type: "Hockey",
    }));
  };

  const fetchDataSet = async () => {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE}/api/AddCard/sets`,
      {
        withCredentials: true, // ✅ sends cookies/session
      });
    const set = response.data.map((set) => ({
      value: set.setId,
      label: set.SetName,
      Set: set.TypeSet,
    }));
    setSetsSelected(set);

    //await adapteSetbyFilteredType();
  };

  // Function to find the team name by ID
  const FindTheTeamNameById = (teamId) => {
    console.log("teamId 491", teamId);
    const team = teams[teamId];
    console.log("team 492", team);
    return team ? team.name : "Unknown Team";
  };

  // Function to fetch team data for a player
  const fetchDataTeamsPerPlayer = async (playerId) => {
    try {
      console.log("playerid 499", playerId);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/Get/TeamByPlayerAndRookie?playerId=${playerId}`
      ,
      {
        withCredentials: true, // ✅ sends cookies/session
      });
      // Log the raw response
      console.log("Raw response:", response.data);
      const uniformList = response.data.map((uniform) => ({
        value: uniform,
        label: FindTheTeamNameById(uniform),
        TeamId: uniform,
      }));
      console.log("uniformlist 506", uniformList);
      return uniformList;
    } catch (error) {
      console.error("Error fetching team data:", error);
      return [];
    }
  };

  // // Usage example
  // const playerId = 123; // Replace with the actual player ID
  // fetchDataTeamsPerPlayer(playerId)
  //   .then((uniformList) => {
  //       setUniformListForThisPlayer(uniformList);
  //   })
  //   .catch((error) => {
  //       console.error('Error setting uniform list:', error);
  //   });

  const fetchCardOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/variation/getCard`
      ,
      {
        withCredentials: true, // ✅ sends cookies/session
      });
      const getCards = response.data.map((getCard) => ({
        value: getCard.IdCardVariation,
        label: getCard.cardName,
        name: getCard.fromSet,
      }));

      setVariation(getCards);
    } catch (error) {
      console.log("Error fetching set options:", error.message);
    }
  };

  const fetchCardVariationOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/variation/getCardVariation`,
      {
        withCredentials: true, // ✅ sends cookies/session
      }
      );
      const variations = response.data.map((variation) => ({
        value: variation.IDVariation,
        label: variation.variationName,
        name: variation.IdCardVariation,
        isAuto: variation.isAuto,
        isPatch: variation.isPatch,
        numbered: variation.numbered,
        isRookie: variation.isRookie,
        isJersey: variation.isJersey,
      }));

      setCardVariation(variations);
    } catch (error) {
      console.log("Error fetching set options:", error.message);
    }
  };

  useEffect(() => {
    fetchData();
   //fetchDataSet();
   // fetchCardOptions();
    fetchCardVariationOptions();
    fetchCollections();
  }, []); // Runs only once on component mount

  // Filters the available sets based on the selected card type
  // useEffect(() => {
  //   adapteSetbyFilteredType();
  // }, [formData.Type]);

  useEffect(() => {
    const filterCardVari = cardVariation.filter(
      (item) => parseInt(item.name) === parseInt(newVariationName.value)
    );
    console.log("cardVariation", cardVariation);
    console.log("newVariationName", newVariationName);
    setFilteredVariation(filterCardVari);
  }, [newVariationName]);

  useEffect(() => {
    console.log("thisnewcardVariation", thisIsANewVariation);
    console.log("thisnewVariationName", thisIsANewVariationName);
  }, [thisIsANewVariation, thisIsANewVariationName]);

  const doesItMatchAnExistingCard = async () => {
    const PlayerId = formData.PlayerId;
    const Type = formData.Type;
    const cardVariation = newVariation.value;
    const YearMade = formData.YearMade;
    const Set = formData.Sets;

    console.log("Trying doesItMatch", "cardVariation ", newVariation);
    console.log("Checking match for existing card:", PlayerId, Type, cardVariation, YearMade, Set);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/select/getMatchingCardId`,
        {
          params: {
            PlayerId: PlayerId,
            Type: Type,
            IDVariation: cardVariation,
            Sets: Set,
            YearMade: YearMade,
          },
        },
      {
        withCredentials: true, // ✅ sends cookies/session
      }
      );
      
    const result = response.data;
    console.log("Query Result:", result);
      if (result.length > 0) {
        return result[0].CardId;  // ✅ Return existing CardId
      } else {
        return formData.cardId || 0; // ✅ Use `formData.cardId` if exists, else return 0
      }
    } catch (error) {
      console.error("Error:", error);
      return 0; // Ensure fallback
    }
  };
  // const adapteSetbyFilteredType = async () => {
  //   console.log("formData.Type,done", formData.Type);
  //   const TypeOfCard = formData.Type;
  //   console.log("formData.Type,done", TypeOfCard);
  //   const filteredOptions = setsSelected.filter(
  //     (option) => option.Set === TypeOfCard
  //   );
  //   console.log("pre-setFilteredSets");
  //   await setFilteredSets(filteredOptions);
  //   console.log(TypeOfCard);
  // };

  // useEffect(() => {
  //   const TypeOfCard = formData.Type;
  //   console.log("formData.Type,early", TypeOfCard);
  //   const filteredOptions = setsSelected.filter(
  //     (option) => option.Set === TypeOfCard
  //   );
  //   console.log("early-setFilteredSets");
  //   setFilteredSets(filteredOptions);
  // }, [setsSelected]);
  const adapteSetbyFilteredType = async (inputValue) => {
    const TypeOfCard = formData.Type;
  
    if (!TypeOfCard || inputValue.length < 3) return; // Ensure both TypeOfCard is selected and input has 3+ characters
  
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/searchbar/sets?TypeOfCard=${TypeOfCard}&searchTerm=${inputValue}`,
      {
        withCredentials: true, // ✅ sends cookies/session
      }
      );
      
      console.log("API Response:", response.data); // Log the response to check its format
  
      // Ensure response.data is an array before mapping
      if (Array.isArray(response.data)) {
        const filteredOptions = response.data.map((set) => ({
          value: set.SetId,
          label: set.SetName,
          InsertFamilyId:set.InsertFamilyId,


        }));
  
        setFilteredSets(filteredOptions); // Update the filtered sets based on the type and search term
      } else {
        console.error("Unexpected API response format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching filtered sets:", error);
    }
  };


  // Extracts the year from a set name string
  function getYearFromSet(str) {
    const year = str.substring(0, 4); // Get the first 4 characters of the string
    return year;
  }

  //Slow the select input change

  const debouncedFetchData = debounce((inputValue) => {
    fetchData(inputValue);
  }, 300);

  const handleInputChangeQuicker = (inputValue) => {
    console.log("still out");
    if (inputValue && inputValue.length >= 3) {
      // Perform the search for players
      console.log("is");
      debouncedFetchData(inputValue);
    }
  };

  // Handles input change for the form
  const handleInputChange = async (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === "checkbox" ? checked : value;
    //ToBeMade if(name='playernotfound'&&)
    console.log("Name : ", name, "Value: ", value, "type :", type);
    if (name === "Graded" && value === "false") {
      await setFormData((prevData) => ({
        ...prevData,
        Graded: false,
        Grade: null,
        GradeCompany: "",
      }));
    }
    if (name === "Graded" && value === "true") {
      await setFormData((prevData) => ({
        ...prevData,
        Graded: true,
        Grade: 10,
        GradeCompany: "PSA",
      }));
    }

    await setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));

    const newErrors = validateForm();

    if (Object.keys(newErrors).length > 0) {
      // Display all errors at once
      setErrors(newErrors);
      return; // Prevent form submission
    }
  };

  // put this next to your other handlers
const handleNumberedChange = (e) => {
  const onlyDigits = e.target.value.replace(/\D/g, ""); // strip anything that's not 0–9
  handleInputChange({ target: { name: "Numbered", value: onlyDigits,type:'text' } });
};

  // Handles input change for the form
  const handleToggleButtonChange = (name) => {
    setFormData((prevData) => {
      // If the button is related to the 'Graded' field, handle it specially
      if (name === "Graded") {
        console.log("Pre-Graded", formData);
        return {
          ...prevData,
          [name]: !prevData[name],
          // When graded is toggled, set additional properties
          Grade: !prevData[name] ? 10 : null,
          GradeCompany: !prevData[name] ? "PSA" : "",
        };
      }
      // For all other toggles, just flip the boolean value
      return {
        ...prevData,
        [name]: !prevData[name],
      };
    });
  };

  const [isDragging, setIsDragging] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  
  const handleDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy"; // Shows a copy cursor
  };
  
  const handleDrop = async (event, fieldName) => {
    event.preventDefault();
    setIsDragging(false);
  
    const file = event.dataTransfer.files[0]; // Assuming single file upload
    if (file) {
      await handleImageChange({ target: { name: fieldName, files: [file] } }); // Mock event
    }
  };
  
// keep your preview logic exactly as-is
const handleImageChange = async (event) => {
  const file = event.target.files?.[0];
  if (!file) return;

  setIsUploading(true);
  try {
    const previewUrl = URL.createObjectURL(file);
    setFrontFile(file || null);

    if (event.target.name === "Image") {
      setFormData((p) => ({ ...p, Image: file }));
      setPreviewImage(previewUrl);
    } else if (event.target.name === "ImageBack") {
      setFormData((p) => ({ ...p, ImageBack: file }));
      setPreviewImageBack(previewUrl);
    }
  } finally {
    setIsUploading(false);
    // later, when you replace the image or unmount:
    // URL.revokeObjectURL(previewUrl)
  }
};



  // Handles Player/Set dropdown selection
  const handleChange = (selectedOption) => {
    if (selectedOption) {
      console.log(`Option selected:`, selectedOption);
      setRookieYearForThisPlayer(0);
      // get the uniformlist
      const playerId = parseInt(selectedOption.value); // Replace with the actual player ID
      console.log("playerId 737", playerId);
      fetchDataTeamsPerPlayer(playerId)
        .then((uniformList) => {
          setUniformListForThisPlayer(uniformList);
          setUniformCurrentlySelected(uniformList[0]);
        })
        .catch((error) => {
          console.error("Error setting uniform list:", error);
        });

      // setPlayerNameTempo(selectedOption)
      setFormData((prevData) => ({
        ...prevData,
        PlayerId: selectedOption.value,
        Name: selectedOption.label,
      }));
      setNewPlayerName(selectedOption);
      if (errors.PlayerId) {
        // Remove the error for PlayerId
        setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          delete updatedErrors.PlayerId;
          return updatedErrors;
        });
      }
      if (selectedOption.rookieYear === null) {
        setRookieYearForThisPlayer(0);
      } else {
        setRookieYearForThisPlayer(selectedOption.rookieYear || 0);

        // ✅ Pre-fill the input field in the next select
        setSetSearchTerm(selectedOption.rookieYear?.toString() || "");
    
        // ✅ Trigger the database search
        handleSetInputChange(selectedOption.rookieYear?.toString() || "");
      }
    } else {
      console.log("player name as been deleted");
      setNewPlayerName("");
      setRookieYearForThisPlayer(0);
      setFormData((prevData) => ({
        ...prevData,
        PlayerId: 0,
      }));
    }
    focusNextField("set");
    setOpenSelect("set")

  };

  const handleChangeUniform = (selectedOption) => {
    if (selectedOption) {
      console.log(`Option selected:`, selectedOption);
      setFormData((prevData) => ({
        ...prevData,
        uniform: selectedOption.value,
      }));
      setUniformCurrentlySelected(selectedOption);
    }
  };

  const handleChangeSet = async(selectedOption) => {
    console.log(`Option selected:`, selectedOption);
    const YearReturn = getYearFromSet(selectedOption.label);
    console.log("currentlyselected :", setsCurrentlySelected);
    setSetsCurrentlySelected(selectedOption);
    const setId = selectedOption.value
    console.log(formData.Type);
    setFormData((prevData) => ({
      ...prevData,
      Sets: setId,
      SetName: selectedOption.label,
      YearMade: YearReturn,
      InsertFamilyId:selectedOption.InsertFamilyId,
    }));
    if (errors.Sets) {
      // Remove the error for PlayerId
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors.Sets;
        return updatedErrors;
      });
    }

     // 👉 NEW: Fetch familyIds and variations from backend
  try {
    const res = await fetch(`${process.env.REACT_APP_API_BASE}/getFamilyAndVariations/${setId}`, {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); ;
    const variations = await res.json();

    const formatted = variations.map(item => ({
      value: item.IdCardVariation,
      label: item.cardName,
      InsertFamilyId:item.InsertFamilyId,
    }));

    console.log('formatted variationname',formatted)
    //setCardVariation(formatted);
     const filteredSuggestions = formatted.filter((item) => {
  // Always exclude if InsertFamilyId is empty or null
  if (!item.InsertFamilyId) return false;

  // If the variation name includes 'Base', check for matching InsertFamilyId
  if (item.label?.toLowerCase().includes('base')) {
    return item.InsertFamilyId === selectedOption?.InsertFamilyId;
  }

  // Otherwise, include the item
  return true;
});

setVariation(filteredSuggestions);
  

  } catch (err) {
    console.error("Error fetching variations from set family:", err);
  }
    focusNextField("variationName");
    setOpenSelect("variationName")
  };

  // Handles Player/Set dropdown selection
  const handleChangeVariationName = (selectedOption) => {
    if (selectedOption) {
      const newCard = selectedOption;
       setNewVariationName(newCard);
      // setNewVariation({ value: "Base", label: "Base" });
       console.log("onchangefiltervariationName", newCard);
       setNewVariationNameId(selectedOption.value);
      setFormData((prevData) => ({
        ...prevData,
        cardName: newCard.label,
      }));
      if (errors.cardName) {
        // Remove the error for PlayerId
        setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          delete updatedErrors.cardName;
          return updatedErrors;
        });
      }

    }
    
    // } else {
    //   const newCard = [0, "", "notusefull"];
    //   setNewVariationName(newCard);
    //   setNewVariationNameId(0);
    //   setFormData((prevData) => ({
    //     ...prevData,
    //     numbered: "",
    //     IsAuto: false,
    //     IsJersey: false,
    //     IsPatch: false,
    //     IsRookie: false,
      
    //     variationName: "",
    //   }));
    // }
    focusNextField("variation");
    setOpenSelect("variation")
  };
  // useEffect(() => {
  //   if (shouldAutoSelectVariation && variation.length > 0) {
  //     handleChangeVariationName(variation[0]);
  //     setShouldAutoSelectVariation(false);
  //   }
  // }, [variation, shouldAutoSelectVariation]);

  const handleChangeVariation = (selectedOption) => {
    if (selectedOption) {
      setNewVariation(selectedOption);
      setFormData((prevData) => ({
        ...prevData,
        Variation: selectedOption.value,
        IsAuto: selectedOption.isAuto,
        IsJersey: selectedOption.isJersey,
        IsRookie: selectedOption.isRookie,
        Numbered: selectedOption.numbered,
        IsPatch: selectedOption.isPatch,
      }));
      console.log("onchangefiltervariation", selectedOption);
      setVariationLocked(true);
      if (errors.Variation) {
        // Remove the error for PlayerId
        setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          delete updatedErrors.Variation;
          return updatedErrors;
        });
      }
    } else {
      const newCard = [0, "", 0];
      setNewVariation(newCard);
      setVariationLocked(false);
      setFormData((prevData) => ({
        ...prevData,
        Numbered: "",
        IsAuto: false,
        IsJersey: false,
        IsPatch: false,
        IsRookie: false,
  
        variationName: "",
      }));
    }
    setOpenSelect('null')
    focusNextField("null");
  };

const validateForm = () => {
  const newErrors = {};

  if (!selectedType || selectedType === "") {
    newErrors.Type = t("Type of card is required");
  }

  // ---- POKÉMON ----
  if (selectedType === "Pokemon") {
    if (!pokemonSet || !pokemonSet.value) {
      newErrors.Sets = t("Set is required");
    }
    if (!pokemonCard || !pokemonCard.value) {
      newErrors.Card = t("Card is required");
    }
    // (Optional) If you want to force a choice for holo:
    // if (!holoOverride) newErrors.Holo = t("Holo selection is required");

    return newErrors; // stop here for Pokémon
  }

  // ---- HOCKEY (UNCHANGED) ----
  if (newPlayerName === "" || formData.PlayerId === "") {
    newErrors.PlayerId = t("A Player is required");
  }

  if (!setsCurrentlySelected || !setsCurrentlySelected.value) {
    newErrors.Sets = t("Set is required");
  }

  if (
    !formData.YearMade ||
    parseInt(formData.YearMade) <= 1850 ||
    parseInt(formData.YearMade) >= parseInt(Date.getFullYear)
  ) {
    newErrors.YearMade = t("Year Made is required");
  }

  if (!newVariationName || newVariationName[1] === "") {
    newErrors.cardName = t("Card Name is required");
  }

  if (!newVariation || newVariation[1] === "") {
    newErrors.Variation = t("Variation of that card is required");
  }

  return newErrors;
};

  
// debounced fetch that SETS OPTIONS
const fetchPokemonSets = useMemo(() => debounce(async (term) => {
  if (!term || term.length < 2) {
    setPokemonSetOptions([]);
    return;
  }
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_BASE}/api/pokemon/sets?searchTerm=${encodeURIComponent(term)}`,
      { withCredentials: true }
    );
    // data can already be {value,label} if your endpoint maps; support both
    const opts = (data || []).map(s => ({
      value: s.value ?? s.SetId,
      label: s.label ?? s.SetName
    }));
    setPokemonSetOptions(opts);
    console.log("fetchPokemonSets ->", term, opts.length);
  } catch (e) {
    console.error("fetchPokemonSets error", e);
    setPokemonSetOptions([]);
  }
}, 300), []);

// clean up debounce on unmount
useEffect(() => () => fetchPokemonSets.cancel && fetchPokemonSets.cancel(), [fetchPokemonSets]);

// whenever input text changes, trigger fetch
useEffect(() => {
  fetchPokemonSets(pokemonSetInput);
}, [pokemonSetInput, fetchPokemonSets]);

// replace your existing fetchPokemonCards with this:
const fetchPokemonCards = useMemo(() => debounce(async (setId, term = "") => {
  try {
    if (!setId) { setPokemonCardOptions([]); return; }

    const API = process.env.REACT_APP_API_BASE;
    // If user typed at least 2 chars, we filter server-side, else we fetch all cards of that set
    const hasQuery = (term?.trim()?.length ?? 0) >= 2;
    const url = hasQuery
      ? `${API}/api/pokemon/cards?setId=${setId}&q=${encodeURIComponent(term)}`
      : `${API}/api/pokemon/cards?setId=${setId}`;

    const res = await fetch(url, { credentials: 'include' });
    const data = await res.json();

  // right before mapping
console.log('[Pokemon] raw data length:', Array.isArray(data) ? data?.length : 'n/a');
console.table(data?.slice?.(0, 10)); // quick overview of keys/values for first 10

const opts = (data || []).map((c, i) => {
  // log the first few in detail to avoid spamming the console
  if (i < 5) {
    console.groupCollapsed(`[Pokemon] c[${i}]`);
    console.log('full object:', c);
    console.log('derived fields preview:', {
      value: c.value ?? c.CardId,
      label: `${c.CardName ?? c.Name ?? ''}${(c.NumberInSet ?? c.Number) ? ` #${c.NumberInSet ?? c.Number}` : ''}${c.RarityName ? ` · ${c.RarityName}` : ''}`,
      rarity: c.Rarity ?? c.RarityName ?? null,
      rarityId: c.RarityId ?? null,
      image: c.ImageFront ?? c.image ?? null,
      setId: c.SetId ?? setId,
      number: c.NumberInSet ?? c.Number ?? null,
    });
    console.groupEnd();
  }

  return {
    value: c.value ?? c.CardId,
    label: c.label ?? `${c.CardName ?? c.Name ?? ""}${(c.NumberInSet ?? c.Number) ? ` #${c.NumberInSet ?? c.Number}` : ""}${c.RarityName ? ` · ${c.RarityName}` : ""}`,
    rarity: c.Rarity ?? c.RarityName ?? null,
    rarityId: c.RarityId ?? null,
    image: c.ImageFront ?? c.image ?? null,
    setId: c.SetId ?? setId,
    number: c.NumberInSet ?? c.Number ?? null,
  };
});

    console.log("fetchPokemonCards ->", setId, term, opts.length);
    setPokemonCardOptions(opts);
  } catch (e) {
    console.error("fetchPokemonCards error", e);
    setPokemonCardOptions([]);
  }
}, 250), []);


// cleanup on unmount
useEffect(() => () => fetchPokemonCards.cancel?.(), [fetchPokemonCards]);

// trigger fetch when user types (and a set is chosen)
// useEffect(() => {
//   if (pokemonSet?.value) fetchPokemonCards(pokemonSet.value, pokemonCardInput);
//   else setPokemonCardOptions([]);
// }, [pokemonCardInput, pokemonSet, fetchPokemonCards]);

useEffect(() => {
  if (pokemonSet?.value) {
    setPokemonCardInput("");                 // clear any previous query
    fetchPokemonCards(pokemonSet.value, ""); // fetch entire set
    // optional: auto-focus & open the Card select
    if (selectRefs?.variationName?.current) {
      selectRefs.variationName.current.focus?.();
      selectRefs.variationName.current.onMenuOpen?.();
    }
  } else {
    setPokemonCardOptions([]);
  }
}, [pokemonSet, fetchPokemonCards]);

// keep these tiny controlled inputs for the async selects


const clearPokemon = () => {
  setPokemonSet(null);
  setPokemonCard(null);
  setPokemonRarity(null);
  setHoloOverride('');
};

// whenever type changes, reset pokemon fields to avoid stale state
useEffect(() => {
  if (selectedType !== "Pokemon") clearPokemon();
}, [selectedType]);

// Small helper to format an eBay query for Pokémon (used by your existing button if any)
function buildPokemonEbayQuery() {
  const parts = [];
  if (pokemonSet?.label) parts.push(pokemonSet.label);
  if (pokemonCard?.label) parts.push(pokemonCard.label);
  if (formData?.Graded && formData?.GradeCompany && formData?.Grade > 0) {
    parts.push(`${formData.GradeCompany} ${formData.Grade}`);
  }
  if (holoOverride) parts.push(holoOverride);
  return parts.join(" ");
}











  //Ici on va faire apparaitre des checkboxs pour les variations (Card name(setName avec substring pour extraire ce que je veux) - Young guns - Fwa-p - The cup - opc plat- Ice/99)
  // Handles form submission
  useEffect(() => {
    console.log("error live ", errors);
  }, [errors]);

  useEffect(() => {
    console.log("List of collection ", collections);
    console.log("liveselectedCollection", selectedCollectionLive);
  }, [collections, selectedCollectionLive]);

  //----------------------------------------Collection
  function fetchCollections() {
    fetch(`${process.env.REACT_APP_API_BASE}/api/collection/getCollectionUser/${userId}`, {
    method: 'GET',
    credentials: 'include',
  })
      .then((response) => response.json())
      .then((data) => {
        console.log("Juste avant fetchCollections", data);
        // Set state with default collection followed by fetched data
        setCollections([
          { ListId: 0, Title: "NotAssigned", collectionCount: 0 },
          ...data,
        ]);
      })
      .catch((error) => {
        console.error("Error fetching collections:", error);
      });
  }

function handleCreateNewCollection(event, isConfirmed) {
  event.preventDefault();

  const currentTitle = createNewCollectionTitle?.trim();

  if (!isConfirmed || !currentTitle || currentTitle.length === 0) {
    toast.error(t("InvalidCollectionTitle"));
    return;
  }

  fetch(`${process.env.REACT_APP_API_BASE}/api/collection/add/collection`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ userId, currentTitle, liveCsrfToken }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.listId) {
        const { listId } = data;
        console.log("Created list ID:", listId);

        setSelectedCollectionLive(
          listId,
          currentTitle,
          `${currentTitle} (0)`
        );

        setCreateNewCollectionTitle("");
        setAllowCreateNewCollection(false);
        fetchCollections();
      } else {
        console.error("Error creating list:", data.error);
        toast.error(t("ErrorCreatingWatchlist"));
      }
    })
    .catch((error) => {
      console.error("Error creating list:", error);
      toast.error(t("ErrorCreatingWatchlist"));
    });
}

  
  //-----------------------------------------------FetchData(Post)/AddCardToCollection---------------------------------------------------
  // Function to insert into cards_cardslist table
  async function insertIntoCardsCardsList(listId, thisUserCardId) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/collection/add/card`,
        {
          listId,
          cardIds: [thisUserCardId],
          liveCsrfToken,
          userId
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": liveCsrfToken,
          },
          withCredentials: true,
        }
      );
  
      if (response.data.success) {
        toast.success(t("Card assigned to collection"));
      }
    } catch (error) {
      toast.error(t("Error adding card to collection"));
      console.error("Error inserting card into cards_cardslist:", error);
    }
  }
  

  function handleCancelCreateCollection() {
    setAllowCreateNewCollection(false);
    setConfirmationVisibleCreateNewCollection(false);
    setCreateNewCollectionTitle("");
 
  }

  const handleCreateNewButtonClick = () => {
    setAllowCreateNewCollection(true);
  };

  const createCollectionLabelNewCollection = (
    <div>
      <label htmlFor="createCollection">Creating a new collection</label>
    </div>
  );
  const collectionNameInputNewCollection = (
    <input
      type="text"
      value={createNewCollectionTitle}
      onChange={(e) => setCreateNewCollectionTitle(e.target.value)}
      placeholder="New collection name"
      maxLength={40}
    />
  );
  /*handleCreateNewCollection()*/
  const confirmButtonNewCollection = (
    <button type="button" className="btn-toggle is-active" onClick={(e) => handleCreateNewCollection(e, true)}>
      Confirm
    </button>
  );
  const cancelButtonNewCollection = (
    <button type="button" className="btn-toggle is-inactive" onClick={() => handleCancelCreateCollection()}>
      Cancel
    </button>
  );


  // }
  const sendToAdminForApproval = async (tableName, id) => {
    try {
        const preInsertAdmin = { tableName, id, UserId: userId };

  const response = await axios.post(
  `${process.env.REACT_APP_API_BASE}/api/admin/InsertIntoApprobation`,
  preInsertAdmin,
  {
    withCredentials: true,
    headers: {
      "x-csrf-token": liveCsrfToken,
    },
  }
);

        toast.success(t("SubmissionSentForApproval"));
    } catch (error) {
        if (error.response?.status === 409) {
     toast.warning(t("AlreadyAwaitingApproval"));
        } else {
          toast.error(t("ErrorSendingForApproval"));
        }
        console.error("❌ Error submitting for admin approval:", error);
    }
};
//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setIsLoading(true);
//     await updateLockedFields();
    
//     let newVariationId = formData.Variation;
//     const newErrors = validateForm();

//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       toast.error(t("Please fill in all required fields"));

//       return; // Prevent form submission
//     }

//     // If there are no errors, proceed with form submission
//     // ...

//     setIsLoading(true);
    
//     let newPlayerId = 0;
//     let playerId = [0];
//     let responseCardId = 0;
//     const AccesUserId = userId;
   
//     try {
//       const lastplayerId = 0;
//       setFormData((prevData) => ({
//         ...prevData,
//       }));
//       if (thisIsANewPlayer) {
//         try {
//  // Player creation
//  if (thisIsANewPlayer) {
//   const tempoNewPlayer = {
//     Type: formData.Type,
//     PlayerName: newPlayerName.label,
//   };
//           const responseInsertPlayerNotFound = await axios.post(
//             `${process.env.REACT_APP_API_BASE}/api/add/NewPlayer`,
//             tempoNewPlayer
//           );
//           newPlayerId = responseInsertPlayerNotFound.data;

//           toast.success(t("New player created successfully"));
//           if ("PlayerId" in lockedFields) {
//             setLockedFields((prevLockedFields) => ({
//               ...prevLockedFields,
//               PlayerId: newPlayerId,
//             }));

//             setFormData((prevData) => ({
//               ...prevData,
//               PlayerId: newPlayerId,
//             }));
//           }
       
//           await sendToAdminForApproval("players", newPlayerId);}
//         } catch (error) {
//           console.error("Error in sendToAdminForEvaluation:", error);
//           throw error; // Re-throw the error to be caught in the handleSubmit function
//         }
//       }
//       let EarlynewVariationNameId = newVariationNameId;
//       if (thisIsANewVariationName) {
//         const preInsert = { cardName: newVariationName.label,InsertFamilyId: newVariationName.InsertFamilyId };
        
//         const insertIntocardvariation = await axios.post(
//           `${process.env.REACT_APP_API_BASE}/api/add/NewVariationName`,
//           preInsert
//         );
//         EarlynewVariationNameId = insertIntocardvariation.data;
     
//         await sendToAdminForApproval("cardvariation", EarlynewVariationNameId);

//         setNewVariationNameId(EarlynewVariationNameId);
//         //doit faire la query et mettre l'option base pour la variation,
//         //Mettre base par defaut et
//         setThisIsANewVariationName(false);
//       }
//       if (thisIsANewVariation) {
//         const preInstert = {
//           IdCardVariation: EarlynewVariationNameId,
//           variationName: newVariation.label,
//           IdSet: formData.Sets||0,
//           isAuto: toIntBool(formData.IsAuto),
//           isPatch: toIntBool(formData.IsPatch),
//           numbered: formData.Numbered === "" ? 0 : formData.Numbered,
//           isRookie: toIntBool(formData.IsRookie),
//           isJersey: toIntBool(formData.IsJersey),
//         };
        
//         const insertIntovariation = await axios.post(
//           `${process.env.REACT_APP_API_BASE}/api/add/Variation`,
//           preInstert
//         );
//          newVariationId = insertIntovariation.data;
//         await sendToAdminForApproval("variation", newVariationId);

//       console.log('test new validation',insertIntovariation)
//       console.log('test new validation2',insertIntovariation.data)
      
//       setThisIsANewVariation(false);
//       }
   
//       if (thisIsANewPlayer) {
//         const formDataToSend = new FormData();
    
//         // Append Image and ImageBack as files (assuming they are File objects)
//         if (formData.Image) formDataToSend.append("Image", formData.Image);
//         if (formData.ImageBack) formDataToSend.append("ImageBack", formData.ImageBack);
      
//         // Append all other form fields
//         const readytoInsert = {
//             PlayerId: newPlayerId,
//             userId: AccesUserId,
//             Type: formData.Type,
//             cardName: formData.cardName,
//             YearMade: formData.YearMade,
//             IsRookie: toIntBool(formData.IsRookie),
//             IsPatch: toIntBool(formData.IsPatch),
//             IsAuto: toIntBool(formData.IsAuto),
//             IsJersey: toIntBool(formData.IsJersey),
        
//             Variation: newVariationId,
//             Numbered: formData.Numbered === "" ? 0 : formData.Numbered,
//             Sets: formData.Sets,
//             SpecialAttribute: formData.SpecialAttribute,
//             NumberBehind: formData.NumberBehind,
//             Graded: formData.Graded,
//             GradeCompany: formData.GradeCompany,
//             Grade: formData.Grade,
//             isPC: toIntBool(formData.isPC),
//             isForSale: toIntBool(formData.isForSale),
//             isForTrade: toIntBool(formData.isForTrade),
//             isOnEbay: toIntBool(formData.isOnEbay),
//             ConditionCard: formData.ConditionCard,
//             EstimateValue: formData.EstimateValue,
//             PaidPrice: formData.PaidPrice,
//             Location: formData.Location,
//             isItAMatch: 0,
//         };
    
//         // Append all text fields into FormData
//         Object.keys(readytoInsert).forEach((key) => {
//             formDataToSend.append(key, readytoInsert[key]);
//         });
    
//         // Send request with multipart/form-data header
//         const response = await axios.post("https://projet-collect-v1-production.up.railway.app/api/add/cards", formDataToSend, {
          
  
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//     withCredentials: true, // ✅ correct for Axios
  
//         });
    
//         toast.success(t("Card created successfully"));
//         playerId = response.data;
    
//     } else {
//         const validation = await doesItMatchAnExistingCard();
//         const formDataToSend = new FormData();
    
//         // Append Image and ImageBack if present
//         console.log('pre-submit formadata',formData)
       
//         if (formData.Image) formDataToSend.append("Image", formData.Image);
//         if (formData.ImageBack) formDataToSend.append("ImageBack", formData.ImageBack);
    
//     const booleanKeys = [
//   "IsRookie", "IsPatch", "IsAuto", "IsJersey",
//   "isPC", "isForSale", "isForTrade", "isOnEbay", "Graded"
// ];

// Object.keys(formData).forEach((key) => {
//   if (key !== "Image" && key !== "ImageBack" && key !=="Variation") {
//     let value = formData[key];
//     if (booleanKeys.includes(key)) {
//       value = toIntBool(value);
//     }
//     formDataToSend.append(key, value);
//   }
// });
//        console.log("Final FormData keys:");
// for (let pair of formDataToSend.entries()) {
//   console.log(pair[0], pair[1]);
// }
//         console.log('newVariationId',newVariationId)
//         formDataToSend.append("Variation", newVariationId);
//         // Append user ID and match validation
//         formDataToSend.append("userId", AccesUserId);
//         formDataToSend.append("isItAMatch", validation);
//        console.log('formDataToSend',formDataToSend)
//         const response = await axios.post("https://projet-collect-v1-production.up.railway.app/api/add/cards", formDataToSend, {
//             headers: {
//                 "Content-Type": "multipart/form-data",
//             },withCredentials: true,
  
//         });
    
//        // ✅ Access `userCardId` properly from `response.data`
// responseCardId = response.data.userCardId;

// console.log('responseCardId', responseCardId, 'response', response);
//         toast.success(t("Card created successfully"));
//     }
    

//       // const AssignToCollection = () => {
//       //   console.log("testassign to ");
//       // setSelectedCollectionLive(
//       //   selectedOption.ListId,
//       //   selectedOption.Title,
//       //   `${selectedOption.Title} (${selectedOption.collectionCount})`
//       // );

//       if (parseInt(selectedCollectionLive?.value) !== 0) {

//         insertIntoCardsCardsList(selectedCollectionLive.value, [responseCardId]);
//         console.log('selectedCollectionLive',selectedCollectionLive)
//         toast.success(t("Card assigned to collection ") + selectedCollectionLive.label);
//       }

//       const cardStatusUpdate = {
//         cardIds: [responseCardId], // Assuming the cardId is the PlayerId based on the earlier code
//         isPcUpdate: toIntBool(formData.isPC),
//         isForSaleUpdate: toIntBool(formData.isForSale),
//         isForTradeUpdate: toIntBool(formData.isForTrade),
//         isOnEbayUpdate: toIntBool(formData.isOnEbay),
//         userId: userId,  // Include userId in the request body
//         liveCsrfToken: liveCsrfToken,  // Include CSRF token for validation
//       };
      
//       const updateResponse = await axios.post(
//         "https://projet-collect-v1-production.up.railway.app/api/collection/update/status",
//         cardStatusUpdate,
//         { withCredentials: true }
//       );
//       // Handle the response as needed
  
//       const cardForSaleForTradeUpdate = {
//         userCardId: [responseCardId],  // Include userCardId from the previous step
//         userId: userId,  // Include userId in the request body
//         isForSaleUpdate: toIntBool(formData.isForSale),  // Update sale status
//         isForTradeUpdate: toIntBool(formData.isForTrade),  // Update trade status
//         Price: formData.SalePrice?? 0,  // Sale price
//         ShippingTemplate: parseInt(formData.ShippingTemplate),  // Shipping template (parsed as integer)
//         Shipping: formData.Shipping,  // Shipping details
//         TradingTemplate: formData.TradingTemplate,  // Trading template
//         tradeValue: formData.EstimateValue?? 0,  // Estimated trade value
//         BestOffer: formData.BestOffer ?? 0,  // Best offer option
//         liveCsrfToken: liveCsrfToken,  // Include CSRF token for validation
//       };

     
//       const updateForSaleForTradeResponse = await axios.post(
//         "https://projet-collect-v1-production.up.railway.app/api/collection/CreateEdit/ForSaleForTrade",
//         cardForSaleForTradeUpdate,{ withCredentials: true }
//       );
//       toast.success(t("Updated successfully"));
//       resetFormData();
//     } catch (error) {
//       setIsLoading(false);
    
//       // 👇 Add this check
//       if (error.response && error.response.status === 400) {
//         const msg = error.response.data?.error || "Missing required data";
//         toast.error(t(msg)); // Will show "No images uploaded" from backend
//       } else {
//         console.error("Unknown error:", error);
//         toast.error(t("Error occurred while creating the card"));
//       }
    
//       setErrorMessage(error.message);
//     }
//     setIsLoading(false);
  
//   };

const handleSubmit = async (event) => {
  event.preventDefault();
  setIsLoading(true);
  await updateLockedFields();

  let newVariationId = formData.Variation;
  const newErrors = validateForm();

  if (Object.keys(newErrors).length > 0) {
    setErrors(newErrors);
    toast.error(t("Please fill in all required fields"));
    setIsLoading(false);
    return; // Prevent form submission
  }

  // =========================
  // 🧩 POKÉMON (new) — early return
  // =========================
  if (selectedType === "Pokemon") {
    try {
      const API = process.env.REACT_APP_API_BASE || `${process.env.REACT_APP_API_BASE}`;

      // 1) Build multipart form (files + usercards fields)
      const fd = new FormData();

      // Files
      if (formData.Image) fd.append("Image", formData.Image);
      if (formData.ImageBack) fd.append("ImageBack", formData.ImageBack);

      // Required links/ids
      fd.append("UserId", userId);
      fd.append("Type", "Pokemon");

      // IMPORTANT: link the selected Pokémon catalog card
      // expects backend to accept PokemonCardId and create cards row if missing
      fd.append("PokemonCardId", String(pokemonCard?.value || "")); // <-- from your Pokémon picker

      // usercards standard fields
      fd.append("NumberBehind", formData.NumberBehind ?? "");
      fd.append("SpecialAttribute", formData.SpecialAttribute ?? "");
      fd.append("Graded", toIntBool(formData.Graded));
      fd.append("GradeCompany", formData.GradeCompany ?? "");
      fd.append("Grade", formData.Grade ?? "");
      fd.append("isPC", toIntBool(formData.isPC));
      fd.append("isForSale", toIntBool(formData.isForSale));
      fd.append("isForTrade", toIntBool(formData.isForTrade));
      fd.append("isOnEbay", toIntBool(formData.isOnEbay));
      fd.append("ConditionCard", formData.ConditionCard ?? "NM");
      fd.append("EstimateValue", formData.EstimateValue ?? 0);
      fd.append("PaidPrice", formData.PaidPrice ?? 0);
      fd.append("Location", formData.Location ?? "");
      // Pokémon-only tweak (optional override of holo pattern)
      if (typeof holoOverride !== "undefined") {
        fd.append("HoloOverride", holoOverride || "");
      }

      // Optional selling fields you already use after creation
      fd.append("SalePrice", formData.SalePrice ?? 0);
      fd.append("ShippingTemplate", formData.ShippingTemplate ?? "");
      fd.append("Shipping", formData.Shipping ?? "");
      fd.append("TradingTemplate", formData.TradingTemplate ?? "");
      fd.append("BestOffer", formData.BestOffer ? 1 : 0);

      // 2) Create Pokémon usercard (server should:
      //    - ensure minimal row in `cards` (Type='Pokemon')
      //    - link to PokemonCards by PokemonCardId
      //    - create usercards row and return { userCardId, cardId }
      const createResp = await axios.post(
        `${API}/api/add/pokemon-usercard`,
        fd,
        { headers: { "Content-Type": "multipart/form-data" }, withCredentials: true }
      );

      const responseCardId = createResp?.data?.userCardId;

      if (!responseCardId) {
        throw new Error("Missing userCardId in response");
      }

      // 3) Assign to collection if any
      if (parseInt(selectedCollectionLive?.value) !== 0) {
        await insertIntoCardsCardsList(selectedCollectionLive.value, [responseCardId]);
        toast.success(t("Card assigned to collection ") + selectedCollectionLive.label);
      }

      // 4) Mirror your status update call (same endpoint as Hockey)
      const cardStatusUpdate = {
        cardIds: [responseCardId],
        isPcUpdate: toIntBool(formData.isPC),
        isForSaleUpdate: toIntBool(formData.isForSale),
        isForTradeUpdate: toIntBool(formData.isForTrade),
        isOnEbayUpdate: toIntBool(formData.isOnEbay),
        userId: userId,
        liveCsrfToken: liveCsrfToken,
      };

      await axios.post(
        `${API}/api/collection/update/status`,
        cardStatusUpdate,
        { withCredentials: true }
      );

      // 5) Mirror your ForSale/ForTrade update (same endpoint as Hockey)
      const cardForSaleForTradeUpdate = {
        userCardId: [responseCardId],
        userId: userId,
        isForSaleUpdate: toIntBool(formData.isForSale),
        isForTradeUpdate: toIntBool(formData.isForTrade),
        Price: formData.SalePrice ?? 0,
        ShippingTemplate: parseInt(formData.ShippingTemplate),
        Shipping: formData.Shipping,
        TradingTemplate: formData.TradingTemplate,
        tradeValue: formData.EstimateValue ?? 0,
        BestOffer: formData.BestOffer ?? 0,
        liveCsrfToken: liveCsrfToken,
      };

      await axios.post(
        `${API}/api/collection/CreateEdit/ForSaleForTrade`,
        cardForSaleForTradeUpdate,
        { withCredentials: true }
      );

      toast.success(t("Card created successfully"));
      resetFormData();
      // optionally reset Pokemon UI bits if you have local state:
      // setPokemonSet(null); setPokemonCard(null); setHoloOverride('');

      setIsLoading(false);
      return; // <- IMPORTANT: stop here (don’t run Hockey code)
    } catch (error) {
      setIsLoading(false);
      if (error.response && error.response.status === 400) {
        const msg = error.response.data?.error || "Missing required data";
        toast.error(t(msg));
      } else {
        console.error("Pokemon submit error:", error);
        toast.error(t("Error occurred while creating the card"));
      }
      setErrorMessage(error.message);
      return;
    }
  }

  // =========================
  // 🏒 HOCKEY — your code below (UNCHANGED)
  // =========================

  setIsLoading(true);

  let newPlayerId = 0;
  let playerId = [0];
  let responseCardId = 0;
  const AccesUserId = userId;

  try {
    const lastplayerId = 0;
    setFormData((prevData) => ({ ...prevData }));

    if (thisIsANewPlayer) {
      try {
        // Player creation
        if (thisIsANewPlayer) {
          const tempoNewPlayer = {
            Type: formData.Type,
            PlayerName: newPlayerName.label,
          };
          const responseInsertPlayerNotFound = await axios.post(
            `${process.env.REACT_APP_API_BASE}/api/add/NewPlayer`,
            tempoNewPlayer
          );
          newPlayerId = responseInsertPlayerNotFound.data;

          toast.success(t("New player created successfully"));
          if ("PlayerId" in lockedFields) {
            setLockedFields((prevLockedFields) => ({
              ...prevLockedFields,
              PlayerId: newPlayerId,
            }));

            setFormData((prevData) => ({
              ...prevData,
              PlayerId: newPlayerId,
            }));
          }

          await sendToAdminForApproval("players", newPlayerId);
        }
      } catch (error) {
        console.error("Error in sendToAdminForEvaluation:", error);
        throw error; // Re-throw the error to be caught in the handleSubmit function
      }
    }

    let EarlynewVariationNameId = newVariationNameId;
    if (thisIsANewVariationName) {
      const preInsert = { cardName: newVariationName.label, InsertFamilyId: newVariationName.InsertFamilyId };

      const insertIntocardvariation = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/add/NewVariationName`,
        preInsert
      );
      EarlynewVariationNameId = insertIntocardvariation.data;

      await sendToAdminForApproval("cardvariation", EarlynewVariationNameId);

      setNewVariationNameId(EarlynewVariationNameId);
      setThisIsANewVariationName(false);
    }

    if (thisIsANewVariation) {
      const preInstert = {
        IdCardVariation: EarlynewVariationNameId,
        variationName: newVariation.label,
        IdSet: formData.Sets || 0,
        isAuto: toIntBool(formData.IsAuto),
        isPatch: toIntBool(formData.IsPatch),
        numbered: formData.Numbered === "" ? 0 : formData.Numbered,
        isRookie: toIntBool(formData.IsRookie),
        isJersey: toIntBool(formData.IsJersey),
      };

      const insertIntovariation = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/add/Variation`,
        preInstert
      );
      newVariationId = insertIntovariation.data;
      await sendToAdminForApproval("variation", newVariationId);

      console.log('test new validation', insertIntovariation);
      console.log('test new validation2', insertIntovariation.data);

      setThisIsANewVariation(false);
    }

    if (thisIsANewPlayer) {
      const formDataToSend = new FormData();

      if (formData.Image) formDataToSend.append("Image", formData.Image);
      if (formData.ImageBack) formDataToSend.append("ImageBack", formData.ImageBack);

      const readytoInsert = {
        PlayerId: newPlayerId,
        userId: AccesUserId,
        Type: formData.Type,
        cardName: formData.cardName,
        YearMade: formData.YearMade,
        IsRookie: toIntBool(formData.IsRookie),
        IsPatch: toIntBool(formData.IsPatch),
        IsAuto: toIntBool(formData.IsAuto),
        IsJersey: toIntBool(formData.IsJersey),

        Variation: newVariationId,
        Numbered: formData.Numbered === "" ? 0 : formData.Numbered,
        Sets: formData.Sets,
        SpecialAttribute: formData.SpecialAttribute,
        NumberBehind: formData.NumberBehind,
        Graded: formData.Graded,
        GradeCompany: formData.GradeCompany,
        Grade: formData.Grade,
        isPC: toIntBool(formData.isPC),
        isForSale: toIntBool(formData.isForSale),
        isForTrade: toIntBool(formData.isForTrade),
        isOnEbay: toIntBool(formData.isOnEbay),
        ConditionCard: formData.ConditionCard,
        EstimateValue: formData.EstimateValue,
        PaidPrice: formData.PaidPrice,
        Location: formData.Location,
        isItAMatch: 0,
      };

      Object.keys(readytoInsert).forEach((key) => {
        formDataToSend.append(key, readytoInsert[key]);
      });

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/add/cards`,
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        }
      );

      toast.success(t("Card created successfully"));
      playerId = response.data;

    } else {
      const validation = await doesItMatchAnExistingCard();
      const formDataToSend = new FormData();

      if (formData.Image) formDataToSend.append("Image", formData.Image);
      if (formData.ImageBack) formDataToSend.append("ImageBack", formData.ImageBack);

      const booleanKeys = [
        "IsRookie", "IsPatch", "IsAuto", "IsJersey",
        "isPC", "isForSale", "isForTrade", "isOnEbay", "Graded"
      ];

      Object.keys(formData).forEach((key) => {
        if (key !== "Image" && key !== "ImageBack" && key !== "Variation") {
          let value = formData[key];
          if (booleanKeys.includes(key)) value = toIntBool(value);
          formDataToSend.append(key, value);
        }
      });

      formDataToSend.append("Variation", newVariationId);
      formDataToSend.append("userId", AccesUserId);
      formDataToSend.append("isItAMatch", validation);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/add/cards`,
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
          withCredentials: true,
        }
      );

      responseCardId = response.data.userCardId;
      console.log('responseCardId', responseCardId, 'response', response);
      toast.success(t("Card created successfully"));
    }

    if (parseInt(selectedCollectionLive?.value) !== 0) {
      insertIntoCardsCardsList(selectedCollectionLive.value, [responseCardId]);
      console.log('selectedCollectionLive', selectedCollectionLive);
      toast.success(t("Card assigned to collection ") + selectedCollectionLive.label);
    }

    const cardStatusUpdate = {
      cardIds: [responseCardId],
      isPcUpdate: toIntBool(formData.isPC),
      isForSaleUpdate: toIntBool(formData.isForSale),
      isForTradeUpdate: toIntBool(formData.isForTrade),
      isOnEbayUpdate: toIntBool(formData.isOnEbay),
      userId: userId,
      liveCsrfToken: liveCsrfToken,
    };

    await axios.post(
      `${process.env.REACT_APP_API_BASE}/api/collection/update/status`,
      cardStatusUpdate,
      { withCredentials: true }
    );

    const cardForSaleForTradeUpdate = {
      userCardId: [responseCardId],
      userId: userId,
      isForSaleUpdate: toIntBool(formData.isForSale),
      isForTradeUpdate: toIntBool(formData.isForTrade),
      Price: formData.SalePrice ?? 0,
      ShippingTemplate: parseInt(formData.ShippingTemplate),
      Shipping: formData.Shipping,
      TradingTemplate: formData.TradingTemplate,
      tradeValue: formData.EstimateValue ?? 0,
      BestOffer: formData.BestOffer ?? 0,
      liveCsrfToken: liveCsrfToken,
    };

    await axios.post(
      `${process.env.REACT_APP_API_BASE}/api/collection/CreateEdit/ForSaleForTrade`,
      cardForSaleForTradeUpdate,
      { withCredentials: true }
    );

    toast.success(t("Updated successfully"));
    resetFormData();
  } catch (error) {
    setIsLoading(false);
    if (error.response && error.response.status === 400) {
      const msg = error.response.data?.error || "Missing required data";
      toast.error(t(msg));
    } else {
      console.error("Unknown error:", error);
      toast.error(t("Error occurred while creating the card"));
    }
    setErrorMessage(error.message);
  }

  setIsLoading(false);
};

  const handleTest = async () => {};

  const customFilterOption = (option, inputValue) => {
    if (inputValue.length >= 3) {
      return option.label.toLowerCase().includes(inputValue.toLowerCase());
    }
    return true;
  };
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      cursor: state.isSelected ? "pointer" : "default", // Only allow cursor as pointer when an option is selected
    }),
  };

  const createOptionPlayer = (label) => ({
    value: 0,
    label,
    rookieYear: 0,
  });

  const handleCreate = async (inputValue) => {
    setIsLoading(true);

    try {
      // Simulate an asynchronous operation with await
      const newOption = createOptionPlayer(inputValue);
      console.log("newoption", newOption);

      // Simulate an asynchronous operation with setTimeout
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setIsLoading(false);
      setOptions((prev) => [...prev, newOption]);
      setFormData((prevData) => ({
        ...prevData,
        playerId: newOption.value,
      }));
      setNewPlayerName(newOption);
      setThisIsANewPlayer(true);
    } catch (error) {
      console.error("Error creating option:", error);
      setIsLoading(false);
    }
  };




  const isDuplicate = async (inputValue) => {
    const cleaned = normalizeInput(inputValue);
  
    const existsLocally =
      variation.some((v) => v.label.toLowerCase() === cleaned.toLowerCase()) ||
      filteredVariation.some((v) => v.label.toLowerCase() === cleaned.toLowerCase());
  
    if (existsLocally) return true;
  
    try {
      // Call directly to `/variation-exists` (not /api/variation-exists)
      const res = await fetch(`/variation-exists?label=${encodeURIComponent(cleaned)}`, {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
      const data = await res.json();
      return data.exists;
    } catch (error) {
      console.error('Error checking variation from API:', error);
      return false;
    }
  };
  
  const isCardVariationDuplicate = async (inputValue) => {
    const cleaned = normalizeInput(inputValue);
  
    // Check local list first (case-insensitive)
    const existsLocally = filteredVariation.some(
      (v) => v.label.toLowerCase() === cleaned.toLowerCase()
    );
  
    if (existsLocally) return true;
  
    try {
      const res = await fetch(`/cardvariation-exists?label=${encodeURIComponent(cleaned)}`, {
      method: 'GET',
      credentials: 'include', // Ensure session cookies are sent with the request
    }); 
      if (!res.ok) throw new Error('Server error');
      
      const data = await res.json();
      return data.exists;
    } catch (error) {
      console.error('Error checking cardvariation from API:', error);
      return false; // fallback: allow it through if API fails
    }
  };
  
  

  const createVariationName = (label) => ({
    value: 0,
    label: label,
    name: "tobedetermine",
    InsertFamilyId:setsCurrentlySelected.InsertFamilyId,
  });

  const handleCreateVariationName = async (inputValue) => {
    
    
    const cleanedInput = normalizeInput(inputValue);
    if (!cleanedInput || cleanedInput.length < 2) {
      toast.error("Please enter a valid variation name.");
      return;
    }
  
    if (await isDuplicate(cleanedInput)) {
      toast.error("This variation already exists.");
      return;
    }

    setIsLoading(true);
    setNewVariation("");
    setVariationLocked(false);
    try {
      // Simulate an asynchronous operation with await
      ResetAttributBecauseVariationCreate();
      const newVariationName = createVariationName(inputValue);
      console.log("newVariationName", newVariationName);
      
      handleCreateVariation("Base");
      // Simulate an asynchronous operation with setTimeout
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setIsLoading(false);
      setVariation((prev) => [...prev, newVariationName]);

      setNewVariationName(newVariationName);
      setNewVariation({ value: "Base", label: "Base" })
      setThisIsANewVariation(true)
      setThisIsANewVariationName(true);
    } catch (error) {
      console.error("Error creating option:", error);
      setIsLoading(false);
    }
  };

  const createVariation = (label) => ({
    value: 0,
    label: label,
    name: "tobedetermine",
  });

  const handleCreateVariation = async (inputValue) => {

    
    const cleanedInput = normalizeInput(inputValue);
    if (!cleanedInput || cleanedInput.length < 2) {
      toast.error("Please enter a valid variation name.");
      return;
    }
  
    if (await isCardVariationDuplicate(cleanedInput)) {
      toast.error("This variation already exists.");
      return;
    }
    setIsLoading(true);
    try {
      // Simulate an asynchronous operation with await
      const newVariation = createVariation(cleanedInput);
      console.log("newVariation", newVariation);
      ResetAttributBecauseVariationCreate();
      // Simulate an asynchronous operation with setTimeout
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsLoading(false);
      setCardVariation((prev) => [...prev, newVariation]);
      setNewVariation(newVariation);
      setThisIsANewVariation(true);
      setVariationLocked(false)
    } catch (error) {
      console.error("Error creating option:", error);
      setIsLoading(false);
    }
  };

  const ResetAttributBecauseVariationCreate = async () => {
    setFormData((prevData) => ({
      ...prevData,
      IsRookie: true,
      IsAuto: false,
      IsJersey: false,
      IsPatch: false,
    
      Numbered: 0,
    }));
  };

const handleTypeClick = (type) => {
  setSelectedType(type);
  //setIsInitialized(false);

  resetHockeyFields();
  resetPokemonFields();

  setPreviewImage(null);
  setPreviewImageBack(null);
  setInputValue("");
  setCurrentSuggestions([]);
  setSearchSuggestions([]);
  setErrors({});

  setFormData((prev) => ({
    ...prev,
    Type: type,
    PlayerId: 0,
    Name: "",
    cardName: "",
    YearMade: "",
    IsRookie: false,
    IsPatch: false,
    IsAuto: false,
    IsJersey: false,
    Variation: "",
    Numbered: "",
    Uniform: 0,
    Sets: "",
    SetName: "",
    InsertFamilyId: "",
    SpecialAttribute: "",
    Image: "",
    ImageBack: "",
    NumberBehind: "",
    Graded: false,
    GradeCompany: "",
    Grade: 0.0,
    ConditionCard: "NM",
    EstimateValue: "0",
    PaidPrice: "0",
    Location: "",
    SalePrice: "",
    ShippingTemplate: "",
    Shipping: "",
    TradingTemplate: "",
    TradeValue: "",
    BestOffer: false,
    SeeMore: false,
    isPC: false,
    isForSale: false,
    isForTrade: false,
    isOnEbay: false,
  }));
};

const handlePriceAndShippingChange = useCallback(
  (newPrice, shippingTemplateId, shipping, bestOffer) => {
    setFormData(prev => {
      // optional: avoid useless state updates
      if (
        prev.SalePrice === newPrice &&
        prev.ShippingTemplate === shippingTemplateId &&
        prev.Shipping === shipping &&
        prev.BestOffer === !!bestOffer
      ) {
        return prev;
      }

      return {
        ...prev,
        SalePrice: Number.isFinite(newPrice) ? newPrice : 0,
        ShippingTemplate: shippingTemplateId ?? null,
        Shipping: shipping ?? 0,
        BestOffer: !!bestOffer,
      };
    });
  },
  [] // no deps needed; setFormData is stable
);


  const handleNumericInputChange = (event) => {
    const { name, value } = event.target;
    const regex = /^[0-9]*\.?[0-9]*$/; // Allow numbers and decimal points
  
    if (regex.test(value)) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  {
    /*################### double slider ######################*/
  }
  const handleSliderChange = (newRange) => {
    setRange(newRange);
  };

  const handleIncrementLocation = () => {
    setFormData((prevData) => ({
      ...prevData,
      Location: incrementLocationOrCardNumber(prevData.Location),
    }));
  };
  function incrementLocationOrCardNumber(value) {
    // Regular expression to match the numeric part at the end of the string
    const regex = /(\d+)$/;
    const match = value.match(regex);

    if (match) {
      const numericPart = parseInt(match[0], 10);
      if (!isNaN(numericPart)) {
        const incrementedValue = value.replace(
          regex,
          (numericPart + 1).toString()
        );
        return incrementedValue;
      }
    }

    return value; // No valid numeric part found, return the original value
  }

  const LockFieldCheckbox = ({
    fieldId,
    fieldName,
    lockedFields,
    toggleFieldLock,
  }) => {
    const isFieldLocked = fieldName in lockedFields;
    // Locked Lock SVG
    const lockedLockIcon = (
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.25 10.0546V8C5.25 4.27208 8.27208 1.25 12 1.25C15.7279 1.25 18.75 4.27208 18.75 8V10.0546C19.8648 10.1379 20.5907 10.348 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.40931 10.348 4.13525 10.1379 5.25 10.0546ZM6.75 8C6.75 5.10051 9.10051 2.75 12 2.75C14.8995 2.75 17.25 5.10051 17.25 8V10.0036C16.867 10 16.4515 10 16 10H8C7.54849 10 7.13301 10 6.75 10.0036V8ZM12 13.25C12.4142 13.25 12.75 13.5858 12.75 14V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V14C11.25 13.5858 11.5858 13.25 12 13.25Z"
          fill="#0071E7"
        />
      </svg>
    );
    // Locked Lock SVG
    const unlockedLockIcon = (
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2.75C9.10051 2.75 6.75 5.10051 6.75 8V10.0036C7.13301 10 7.54849 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.40931 10.348 4.13525 10.1379 5.25 10.0546V8C5.25 4.27208 8.27208 1.25 12 1.25C15.1463 1.25 17.788 3.4019 18.5373 6.31306C18.6405 6.7142 18.3991 7.12308 17.9979 7.22633C17.5968 7.32957 17.1879 7.08808 17.0846 6.68694C16.5018 4.42242 14.4453 2.75 12 2.75ZM12.75 14C12.75 13.5858 12.4142 13.25 12 13.25C11.5858 13.25 11.25 13.5858 11.25 14V18C11.25 18.4142 11.5858 18.75 12 18.75C12.4142 18.75 12.75 18.4142 12.75 18V14Z"
          fill="white"
        />
      </svg>
    );

    return (
      <div className="input-icon-container">
        <input
          type="checkbox"
          id={fieldId}
          checked={isFieldLocked}
          onChange={() => toggleFieldLock(fieldName)}
          style={{ display: "none" }} // Optionally hide the checkbox to only use the SVG for interaction
        />
        <label htmlFor={fieldId}>
          {isFieldLocked ? lockedLockIcon : unlockedLockIcon}
        </label>

        {isFieldLocked && fieldName === "Location" && (
          <input
            type="checkbox"
            id={`${fieldId}Increment`}
            name={`${fieldName}Increment`}
            checked={`${fieldName}Plus1` in lockedFields}
            onChange={() => toggleFieldLock(`${fieldName}Plus1`)}
          />
        )}
      </div>
    );
  };

  const ToggleButtonGradedRaw = ({ label, active, onChange }) => {
    return (
      <button
        type="button"
        className={`toggle-button ${active ? "active" : ""}`}
        onClick={onChange}
      >
        {label}
      </button>
    );
  };

  const ToggleButton = ({ label, name, value, onChange, disabled,tabindex }) => {
    const handleClick = () => {
      if (!disabled) {
        onChange(name, !value);
      }
    };

    return (
      <button
        type="button"
        className={`btn-toggle ${value ? "is-active" : "is-inactive"} ${
          disabled ? "disabled" : ""
        }`}
        onClick={handleClick}
        disabled={disabled} // This will apply the native HTML disabled attribute
        aria-pressed={value}
        tabIndex={tabindex}
      >
        {t(label)}
      </button>
    );
  };

  const GradingCompanyAndGradeSelection = ({ formData, setFormData }) => {
    const gradingCompanies = ["PSA", "BGS", "SGC", "MINT"];
    const additionalCompanies = [
      "ACA",
      "AGS",
      "ASA",
      "BCCG",
      "CGC",
      "CSG",
      "GAI",
      "HGA",
      "KSA",
      "MBG",
      "MINT",
      "OverTime",
      "PWI",
      "SFTB",
      "Other",
    ]; // Additional grading companies for the dropdown

    const gradeButtons = [10, 9.5, 9, 8.5, 8];
    const lowerGrades = [
      7.5, 7, 6.5, 6, 5.5, 5, 4.5, 4, 3.5, 3, 2.5, 2, 1.5, 1,
    ];

    const handleCompanySelect = (company) => {
      setFormData({
        ...formData,
        GradeCompany: company,
      });
    };

    const handleGradeButtonClick = (grade) => {
      setFormData({
        ...formData,
        Grade: grade,
      });
    };

    const handleGradeDropdownChange = (e) => {
      setFormData({
        ...formData,
        Grade: e.target.value,
      });
    };

    return (
      <div>
        <div>
          <label>{t("Grading company")}</label>
          <div className="flex-h gap">
            {gradingCompanies.map((company) => (
              <button
                key={company}
                
              className={`btn-toggle ${formData.GradeCompany === company ? "is-active" : "is-inactive"}`}
                onClick={() => handleCompanySelect(company)}
              >
                {company}
              </button>
            ))}
            <select
            
            styles={searchSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
             // className="custom-dropdown"
              value={
                gradingCompanies.includes(formData.GradeCompany)
                  ? ""
                  : formData.GradeCompany
              }
              onChange={(e) => handleCompanySelect(e.target.value)}
            >
              <option value="">{t("Other")}</option>
              {additionalCompanies.map((company) => (
                <option key={company} value={company}>
                  {company}
                </option>
              ))}
            </select>
          </div>
        </div>
        <label>{t("Grade")}</label>
        <div className="flex-h gap">
          {gradeButtons.map((grade) => (
            <button
              key={grade}
              className={`btn-toggle ${formData.Grade === grade ? "is-active" : "is-inactive"}`}
           
              onClick={() => handleGradeButtonClick(grade)}
            >
              {grade}
            </button>
          ))}

          <select
                    styles={searchSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
            value={formData.Grade < 8 ? formData.Grade : ""}
            onChange={handleGradeDropdownChange}
          >
            <option value="">{t("Select Grade")}</option>
            {lowerGrades.map((grade) => (
              <option key={grade} value={grade}>
                {grade
                }
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };

function generateEbaySearchUrl(formData, newVariation) {
  const queryParts = [];

  const lowerCardName = formData?.cardName?.toLowerCase() || "";
  const lowerVariation = newVariation?.toLowerCase() || "";

  // Set + card number + player
  if (formData?.SetName) queryParts.push(formData.SetName);
  if (formData?.NumberBehind) queryParts.push(`#${formData.NumberBehind}`);
  if (formData?.Name) queryParts.push(formData.Name);

  // Card name (skip if contains "base")
  if (formData?.cardName && !/base/i.test(formData.cardName)) {
    queryParts.push(formData.cardName.trim());
  }

  // Variation (skip if contains "base")
  if (newVariation && !/base/i.test(newVariation.trim())) {
    queryParts.push(newVariation.trim());
  }

  // Graded
  const isGraded =
    formData?.Graded === true ||
    formData?.Graded === "true" ||
    formData?.Graded === 1;

  if (isGraded && formData?.GradeCompany && formData?.Grade > 0) {
    queryParts.push(`${formData.GradeCompany} ${formData.Grade}`);
  }

  // Keywords (only if not already present)
  if (formData?.IsAuto && !lowerCardName.includes("auto") && !lowerVariation.includes("auto")) {
    queryParts.push("auto");
  }

  if (formData?.IsPatch && !lowerCardName.includes("patch") && !lowerVariation.includes("patch")) {
    queryParts.push("patch");
  }

  if (formData?.IsJersey && !lowerCardName.includes("jersey") && !lowerVariation.includes("jersey")) {
    queryParts.push("jersey");
  }

  const query = queryParts.join(" ");
  const userLocale = navigator.language || navigator.userLanguage;
  const ebayBaseUrl = userLocale.includes("CA")
    ? "https://www.ebay.ca/sch/i.html"
    : "https://www.ebay.com/sch/i.html";

  return `${ebayBaseUrl}?_nkw=${encodeURIComponent(query)}&LH_Sold=1`;
}

  // const ShowCompleteCard = ({ formData }) => {
  //   // Ensure this matches the structure and class names in your SCSS
  //   return (
  //     <div className="cardcontentForm">
  //       <div className="card">
  //         <div className="img">
  //           <img
  //             className="card-image"
  //             src={formData.Image}
  //             alt="Card Preview"
  //           />
  //           <div className="filter"></div>
  //           <div className="card-isWhat">
  //             {formData.IsRookie === 1 && (
  //               <div className="patch spe">
  //                 <p className="strong">RC</p>
  //               </div>
  //             )}
  //             {formData.IsPatch === 1 && (
  //               <div className="patch">
  //                 <p>Patch</p>
  //               </div>
  //             )}
  //             {formData.IsJersey === 1 && (
  //               <div className="patch">
  //                 <p>Jersey</p>
  //               </div>
  //             )}
  //             {formData.IsAuto === 1 && (
  //               <div className="patch">
  //                 <p>Auto</p>
  //               </div>
  //             )}
  //             {formData.IsTribute === 1 && (
  //               <div className="patch">
  //                 <p>Tribute</p>
  //               </div>
  //             )}
  //           </div>
  //         </div>
  //         <div className="txt">
  //           <div className="justify">
  //             <h4 className="card-name">{formData.Name}</h4>

  //             <p className="card-IDcard ">#{formData.NumberBehind}</p>
  //           </div>
  //           <p className="card-set">{formData.SetName}</p>
  //           <div className="flex-h">
  //             <p className="card-variation">{`${formData.cardName} - ${newVariation.label}`}</p>
  //             {formData.Numbered && formData.Numbered !== "0" ? (
  //               <p className="card-numbered"> / {formData.Numbered} </p>
  //             ) : null}
  //           </div>
  //           <div className="flex-h">
  //             {/* <div className="justify bottom"> */}
  //             <div>
  //               <h4 className="card-value">
  //                 ({t("Estimate/TV")}) {formData.EstimateValue}$
  //               </h4>
  //               {formData.SalePrice ? (
  //                 <h4 className="card-value">
  //                   ({t("Price")}) {formData.SalePrice}$
  //                 </h4>
  //               ) : null}
  //             </div>
  //             {/* CTA section, if needed */}

  //             <div className="card-isfor">
  //               {formData.isForSale === 1 && (
  //                 <div className="patch ">
  //                   <p>{t("ForSale")}</p>
  //                 </div>
  //               )}
  //               {formData.isPC === 1 && (
  //                 <div className="patch ">
  //                   <p>PC</p>
  //                 </div>
  //               )}
  //               {formData.isForTrade === 1 && (
  //                 <div className="patch">
  //                   <p>{t("ForTrade")}</p>
  //                 </div>
  //               )}
  //               {formData.isOnEbay === 1 && (
  //                 <div className="patch">
  //                   <p>{t("OnEbay")}</p>
  //                 </div>
  //               )}
  //             </div>
  //           </div>
  //           {/* </div> */}
  //         </div>
  //       </div>
  //       {/* {formData.ImageBack && (
  //               <div className="mt-2 text-left">
  //                 <label>Back</label>
  //                 <img src={formData.ImageBack} alt="Selected" className="card-image" />
  //               </div>
  //             )} */}
  //     </div>
  //   );
  // };

const MAX_CHIPS = 8;

function ChipsFromLabel({ label }) {
  const parts = label.split(" - ").filter((p) => !/^\d{4}-\d{2}$/.test(p));
  if (parts.length < 4) return null;

  const chips = parts.slice(3); // everything after title parts
  const shown = chips.slice(0, MAX_CHIPS);
  const overflow = Math.max(0, chips.length - shown.length);

  return (
    <div className="qs__chips">
      {shown.map((txt, i) => (
        <span key={i} className="qs__chip">{txt}</span>
      ))}
      {overflow > 0 && <span className="qs__chip qs__chip--more">+{overflow}</span>}
    </div>
  );
}

const formatOptionLabel = (opt) => {
  const full = opt.label || "";
  const parts = full.split(" - ").filter((p) => !/^\d{4}-\d{2}$/.test(p));
  const title = parts.slice(0, 4).join(" - ");

  return (
    <div className="qs__item">
      {opt.Image ? (
        <div className="qs__thumb">
          <img
            src={opt.Image}
            alt=""
            loading="lazy"
          />
        </div>
      ) : (
        <div className="qs__thumb qs__thumb--placeholder" aria-hidden="true" />
      )}

      <div className="qs__text">
        <div className="qs__title" title={title}>{title}</div>
        <ChipsFromLabel label={full} />
      </div>
    </div>
  );
};

  useEffect(() => {
    if (formData) {
      // Logs when formData changes
      console.log('card-isFor section data:', formData.isForSale, formData.isPC, formData.isForTrade, formData.isOnEbay);
      
      // Check each section for debugging
      if (formData.isForSale) console.log('For Sale section should be visible');
      if (formData.isPC) console.log('PC section should be visible');
      if (formData.isForTrade) console.log('For Trade section should be visible');
      if (formData.isOnEbay) console.log('On Ebay section should be visible');
      console.log('all of formData', formData)
    }
  }, [formData]);

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#222",
      border: "1px solid #444",
      color: "white",
      borderRadius: "8px",
      padding: "6px",
      "&:hover": { borderColor: "#0066FFED" },
      minWidth:'23vw',
      minHeight: '50px'
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#181818",
      borderRadius: "6px",
      padding: "5px",
      border: "1px solid #444",
      
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "#F5F5F5",
      backgroundColor: state.isSelected ? "#0066FFED" : "#222",
      padding: "5px",
      borderRadius: "6px",
      "&:hover": { backgroundColor: "#0066FFED", color: "white" },
      
    }),
  };

  const ancienSelectStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "black", // Set the background color to black
      color: "white",
      // Set the text color to white
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "black", // Set the background color of the dropdown menu to black
      color: "white",
      // Set the text color of the dropdown menu to white
    }),
    option: (provided, state) => ({
      ...provided,
      color: "white", // Set the text color for selected and non-selected options
      backgroundColor: state.isSelected ? "blue" : null,
      // Set the background color for selected options
      "&:hover": {
        backgroundColor: "blue", // Set the background color for hover effect
        color: "white", // Set the text color for hover effect
      },
    }),
  }

  const stylingSelect={
    control: (provided) => ({
      ...provided,
      backgroundColor: "#222", // Set the background color to black
      color: "white", // Set the text color to white
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#222", // Set the background color of the dropdown menu to black
      color: "white", // Set the text color of the dropdown menu to white
    }),
    option: (provided, state) => ({
      ...provided,
      color: "white", // Set the text color for selected and non-selected options
      backgroundColor: state.isSelected ? "#0066FFED" : null, // Set the background color for selected options
      "&:hover": {
        backgroundColor: "#0066FFED", // Set the background color for hover effect
        color: "white", // Set the text color for hover effect
      },
    }),
  }
 
  //*##############################################################################################################################
    if (loading) return null;
    // if(!userId&&!isAuthenticated)
    //   navigate('/login')
  return (
    <>
       <SeoHelmet type="createCard" />
     
     
        <form className="formBackground create-card-form">

           {/* 🔵 Progress Bar */}

          {/* Left Section */}
          <div className="left-section" >
             <div className="panel">
              <p className="panel-title">{t('Basic Details')}</p>
            <div className="form-group">
                     <ul className="nav nav-tabs seg-tabs" role="tablist" aria-label="Card type" style={{ marginTop: '1em' }}>
  <li className="nav-item" role="presentation">
    <button
      type="button"
      name="Type"
      role="tab"
      aria-selected={selectedType === "Hockey"}
      className={`nav-link ${selectedType === "Hockey" ? "active" : ""}`}
      onClick={() => handleTypeClick("Hockey")}
    >
      <FontAwesomeIcon icon={faHockeyPuck} /> Hockey
    </button>
  </li>

  <li className="nav-item" role="presentation">
    <button
      type="button"
      name="Type"
      role="tab"
      aria-selected={selectedType === "Pokemon"}
      className={`nav-link ${selectedType === "Pokemon" ? "active" : ""}`}
      onClick={() => handleTypeClick("Pokemon")}
      
    >
      Pokémon
    </button>
  </li>
</ul>
          
            </div>
 <div className="form-group">
            <label htmlFor="QuickSearch">{t('QuickSearch')}
</label>
       
<div className="select-wrapper search">
          <Select
  classNamePrefix="qs"
  className="search-select"
  styles={searchSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
  placeholder={t("Search for a DeepSearch")}
 
  value={null}                              // ← important
  inputValue={inputValue}
  onInputChange={(v, meta) => {
    // ignore clears caused by menu-close etc.
    if (meta.action === "input-change") handleInputChange2(v);
    if (meta.action === "menu-close")  {markUserNav(); return;}  
  }}
  options={currentSuggestions}
  formatOptionLabel={formatOptionLabel}
  // menuIsOpen={inputValue.length >= 2 && currentSuggestions.length > 0}
  openMenuOnFocus={true}
  openMenuOnClick={true}
 
  noOptionsMessage={() =>
    inputValue.length < 2 ? t("Type at least 4 letters") : t("No results")
  }
  filterOption={() => true} // suggestions are pre-filtered upstream
  onChange={(opt) => {
    if (opt) {handleSearch2(opt)
   
    };
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter" && currentSuggestions.length > 0) {
      handleSearch2(currentSuggestions[0]);
    }
  }}
  // Inline clear button that resets input as well
  components={{
    ClearIndicator: (props) => (
      <div
        {...props.innerProps}
        onMouseDown={(e) => {
          e.preventDefault();
          setInputValue("");
          setCurrentSuggestions([]);
        }}
        className="qs__clear"
        aria-label={t("Clear")}
        title={t("Clear")}
      >
        ×
      </div>
    ),
  }}
/>

  {inputValue &&   (
    <button className="clear-btn"  onClick={() => {
      setInputValue("");
      setCurrentSuggestions([]);
    }}>❌</button>
  )}
</div>
</div>
            <div className="form-group">
              {!isPokemon?(<>
              <label htmlFor="PlayerId">{t("Player")}: *</label>
         
              {errors.PlayerId && <p className="error-message">{errors.PlayerId}</p>}
              <div style={{ width: "100%"}}>
                <div className="lockGroup">
                  <Select
                  ref={selectRefs.player}
                    key={selectKey}
                    placeholder={t("Search for a Player")}
              
                    isDisabled={testisLoading}
                    isLoading={testisLoading}
                    onChange={handleChange}
                    //menuIsOpen={true}
                    styles={formSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
                    //onCreateOption={handleCreate}
                    //onInputChange={handleInputChangeQuicker}
                    onInputChange={(input, { action }) => {
                      if (action === "input-change") {
                        handlePlayerInputChange(input,false);
                      } else if (action === "menu-close") {
                        // Reset typed value if needed (optional)
                      }
                    }}
                    options={options}
                    value={newPlayerName}
                    className="form-control"
                   
                    filterOption={createFilter({ ignoreAccents: false })}
                    tabIndex={2}
  onKeyDown={(e) => {
    if (e.key === "Enter" && options.length > 0) {
      handleChange(options[0]);
    }
  }}
                  />
                  {/*()=>toggleFieldLock('PlayerId')}>*/}
                  {/* <button onClick={toggleFieldLock('PlayerId')}>
                    { isFieldsLocked && 'PlayerId' in lockedFields ? "Unlock PlayerId" : "Lock PlayerId"}  
                    </button> */}
                  <LockFieldCheckbox
                    fieldId="lockPlayerId"
                    fieldName="PlayerId"
                    lockedFields={lockedFields}
                    toggleFieldLock={toggleFieldLock}
                  />
                </div>
                {rookieYearForThisPlayer !== 0 && (
                  <label htmlFor="Labeltest" className="mt-2">
                    {t("Rookie Year")}: {rookieYearForThisPlayer}
                  </label>
                )}
                <div style={{ width: "100%" }}>
                  <label htmlFor="Uniform">
                    {t("Uniform")} {t('(Impact the filter - Team)')}
                  </label>
                
                  
                  <Select
                    options={uniformListForThisPlayer}
                    onChange={handleChangeUniform}
                    placeholder={t("Search for a Uniform")}
                    filterOption={createFilter({ ignoreAccents: false })}
                    className="form-control"
                    styles={formSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
                    value={{
                      label: uniformCurrentlySelected?.label,
                      value: uniformCurrentlySelected?.value,
                    }}
                    disabled={
                      uniformListForThisPlayer === "" ||
                      uniformCurrentlySelected === "" ||
                      newPlayerName === ""
                    }
                    tabIndex={3}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && uniformListForThisPlayer.length > 0) {
                        handleChangeUniform(uniformListForThisPlayer[0]);
                      }
                    }}
                                        onFocus={markUserNav}
  onMenuOpen={markUserNav}
  onMouseDown={markUserNav}
                  />
                 
  
                </div>

                <div style={{ width: "100%" }}>
                 
                
                  <div className="form-group">
                  
                    <label htmlFor="Sets">Set: *  2019-20 Upper Deck The Cup</label>
                    {errors.Sets && <p className="error-message">{errors.Sets}</p>}
                    <div className="lockGroup">
                    <Select
  ref={selectRefs.set}         
  options={filteredSets}
  onChange={handleChangeSet}
  placeholder={t("Search for a Set")}
  filterOption={createFilter({ ignoreAccents: false })}
  className="form-control"
  styles={formSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
  value={setsCurrentlySelected}
 // menuIsOpen={openSelect === "set" || (filteredSets.length > 0 && setSearchTerm.length >= 3)}
  //inputValue={setsCurrentlySelected.label}
     onFocus={markUserNav}
  onMenuOpen={markUserNav}
  onMouseDown={markUserNav}
  onInputChange={(input, { action }) => {
    if (action === "input-change") {
      setSetSearchTerm(input);
      handleSetInputChange(input);
    }
  }}

  tabIndex={4}
  onKeyDown={(e) => {
    if (e.key === "Enter" && filteredSets.length > 0) {
      handleChangeSet(filteredSets[0]);
    }
  }} // Adding onInputChange for filtering sets
/>
                      <LockFieldCheckbox
                        fieldId="lockSet"
                        fieldName="Sets"
                        lockedFields={lockedFields}
                        toggleFieldLock={toggleFieldLock}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>e.g : Young Guns</label>
                {errors.cardName && <p className="error-message">{errors.cardName}</p>}
                <div className="lockGroup">
                
                   
                  <CreatableSelect
                    placeholder={t("Select the card Name")}
                 
                    ref={selectRefs.variationName} 
                    isDisabled={testisLoading}
                    isLoading={testisLoading}
                    onChange={handleChangeVariationName}
                    onCreateOption={handleCreateVariationName}
                    options={variation}
                    //menuIsOpen={openSelect==="variationName"&&variation.length > 0}
                    value={newVariationName}
                    className="form-control"
                    styles={formSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
                    filterOption={createFilter({ ignoreAccents: false })}
                    
                    onInputChange={(input, { action }) => {
                      if (action === "input-change") {
                        handleCardInputChange(input);
                      }
                    }}
                    tabIndex={5}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && variation.length > 0) {
                        handleCardInputChange(variation[0]);
                      }
                    }}
                 onFocus={markUserNav}
  onMenuOpen={markUserNav}
  onMouseDown={markUserNav}

                  />
                  <LockFieldCheckbox
                    fieldId="lockCardName"
                    fieldName="newVariationName"
                    lockedFields={lockedFields}
                    toggleFieldLock={toggleFieldLock}
                  />
                </div>
              </div>

              <label>e.g : HighGloss - ClearCut</label>
              {errors.Variation && <p className="error-message">{errors.Variation}</p>}
              <div className="lockGroup">
             
             

                <CreatableSelect
                  placeholder={t("Select the variation")}
                  ref={selectRefs.variation} 

                  //menuIsOpen={openSelect === "variation"}
                
                  isDisabled={testisLoading}
                  isLoading={testisLoading}
                  onChange={handleChangeVariation}
                  onCreateOption={handleCreateVariation}
                  options={filteredVariation}
                  value={newVariation}
                  className="form-control"
                            styles={formSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
                  filterOption={createFilter({ ignoreAccents: false })}
                  tabIndex={6}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && filteredVariation.length > 0) {
                      handleChangeVariation(filteredVariation[0]);
                    }
                  }}
                                  onFocus={markUserNav}
  onMenuOpen={markUserNav}
  onMouseDown={markUserNav}
  onBlur={() => setOpenSelect("null")}
                />
                <LockFieldCheckbox
                  fieldId="lockVariation"
                  fieldName="newVariation"
                  lockedFields={lockedFields}
                  toggleFieldLock={toggleFieldLock}
                />
              </div>

              <label>{t('Details')}</label>

              {/* <div className="flex-h gap" style={{paddingBottom:'0px'}}> */}
              <div className="attribute-grid">
                <ToggleButton
                  label="Rookie (RC)"
                  name="IsRookie"
                  value={formData?.IsRookie===true ||formData?.IsRookie===1}
                  onChange={() => handleToggleButtonChange("IsRookie")}
                  disabled={variationLocked}
                />
                <ToggleButton
                  label="Patch"
                  name="IsPatch"
                  value={formData?.IsPatch}
                  onChange={() => handleToggleButtonChange("IsPatch")}
                  disabled={variationLocked}
                />

                <ToggleButton
                  label="Jersey"
                  name="IsJersey"
                  value={formData?.IsJersey}
                  onChange={() => handleToggleButtonChange("IsJersey")}
                  disabled={variationLocked}
                />
                <ToggleButton
                  label="Auto"
                  name="IsAuto"
                  value={formData?.IsAuto}
                  onChange={() => handleToggleButtonChange("IsAuto")}
                  disabled={variationLocked}
                />

<div style={{width:'100%',display:'flex',justifyContent:'center',alignContent:'center'}} >             
<label style={{alignContent:'center'}}>{t('IsThisCardNumbered')} /?? </label>



      <input
  type="text"
  name="Numbered"
  placeholder="e.g. /999"
  value={formData?.Numbered}
  onChange={handleNumberedChange}          
  disabled={variationLocked}
  className="form-control reg"
  style={{ width: "6rem",textAlign:'center'}}
  inputMode="numeric"                      
  pattern="[0-9]*"                        
  maxLength={6}                             
  onKeyDown={(e) => {                 
    const allowed = [
      "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"
    ];
    if (!/[0-9]/.test(e.key) && !allowed.includes(e.key)) e.preventDefault();
  }}
/>
</div>
 </div>
</>) : ( <>
<div className="form-group">
    {/* Pokémon Set */}
  <label>{t("Set")}</label>
<Select
  inputValue={pokemonSetInput}
  onInputChange={(val, meta) => {
    if (meta.action === "input-change") setPokemonSetInput(val);
  }}
  onMenuOpen={() => {
    // pre-warm results with current text (or fetch popular sets if empty)
    fetchPokemonSets.flush?.();          // runs pending call immediately if any
    if (!pokemonSetInput) fetchPokemonSets("sv"); // example seed; or fetch top recent
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter") e.preventDefault();
  }}
  styles={searchSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
  placeholder={t("SearchPokemonSet")}
  value={pokemonSet}
  onChange={(opt) => {
    setPokemonSet(opt);
    setPokemonSetInput(opt?.label || "");
    setPokemonCard(null); // reset card when set changes
  }}
  options={pokemonSetOptions}
  isClearable
/>

    {/* Pokémon Card (depends on Set) */}
    <label className="mt-2">{t("Card")}</label>

<Select
  isDisabled={!pokemonSet?.value}
  inputValue={pokemonCardInput}
  onInputChange={(val, meta) => {
    if (meta.action === "input-change") setPokemonCardInput(val);
    if (meta.action === "set-value" || meta.action === "menu-close" || meta.action === "input-blur") {
      setPokemonCardInput("");        // ✅ clear search text so the selected label shows
    }
  }}
  styles={searchSelectStyles}
  menuPortalTarget={document.body}
  menuPosition="fixed"
  menuPlacement="auto"
  placeholder={pokemonSet?.value ? t("SearchPokemonCard") : t("PickSetFirst")}
  value={pokemonCard}
  onChange={(opt) => {
    setPokemonCard(opt);
    setPokemonCardInput("");          // ✅ also clear here
    setPokemonRarity(opt?.rarity ?? null);
    console.log("Selected Pokémon card:", opt);
    setFormData((prev) => ({
      ...prev,
      NumberBehind: opt?.number ?? "",
    }));
  }}
  options={pokemonCardOptions}
  
  isClearable
  getOptionValue={(o) => String(o.value)}   // optional but robust
  getOptionLabel={(o) => o.label}
/>


    {/* Optional: override Holo pattern if your catalog doesn’t store it consistently */}
    <div className="mt-2">
      <label>{t("HoloOptional")}</label>
      <CreatableSelect
        value={holoOverride ? { value: holoOverride, label: holoOverride } : null}
        onChange={(opt) => setHoloOverride(opt?.value || "")}
        onCreateOption={(val) => setHoloOverride(val)}
        placeholder="Ex: Holo, Reverse Holo, Cosmos, Cracked Ice"
        styles={compactSelectStyles}
        isClearable
      />
    </div>

    {/* Keep your condition/graded/price blocks, they already bind to formData */}
  </div>
  </>) }
             
        
<div className="attribute-grid" style={{justifyContent:'space-around'}}>
            <label htmlFor="SpecialAttribute">
                {t('SpecialPlaceholder')}
               
              </label>

              <label htmlFor="NumberBehind">{t('Number Behind')}#:</label>
 </div>
              <div className="flex-h" style={{justifyContent:'space-between',gap:'4vw'}}>


             
              <input
                type="text"
                name="SpecialAttribute"
                placeholder="SSP/4clr"
                value={formData?.SpecialAttribute}
                onChange={handleInputChange}
                style={{marginLeft:'2vw',textAlign:'center'}}
                className="form-control reg"
                
                tabIndex={7}
                
              />

              

              <div className="lockGroup">
                <input
                  type="text"
                  name="NumberBehind"
                  placeholder="CM-197"
                  value={formData?.NumberBehind}
                  onChange={handleInputChange}
                  className="form-control reg"
                  style={{width:'7rem',textAlign:'center'}}
                  tabIndex={8}
                />

                <LockFieldCheckbox
                  fieldId="lockNumberBehind"
                  fieldName="NumberBehind"
                  lockedFields={lockedFields}
                  toggleFieldLock={toggleFieldLock}
                />
              </div>
       
             
            </div>
            </div>
           
          </div>

          </div>
          {/* Right Section */}
          <div className="mid-section">

              <div className="panel">
              <p className="panel-title">Condition</p>
            {/* <div className="form-check"></div> */}
        {/* <label>{t("Graded")}? *</label> */}
            <div className="attribute-grid">
              <ToggleButton
                label="Raw"
                name="Graded"
                value={!formData?.Graded === true||!formData?.Graded === 'Graded'}
                onChange={() => handleToggleButtonChange("Graded")}
                tabindex={formData?.isForSale?15:13}
              />
              <ToggleButton
                label="Graded"
                name="Graded"
                value={!formData?.Graded === false ||!formData?.Graded === 'Raw'}
                onChange={() => handleToggleButtonChange("Graded")}
                tabindex={formData?.isForSale?16:14}
              />

              {/* <ToggleButtonGradedRaw
                label="Graded"
                name="Graded"
                active={formData.Graded === false} // Button is active if formData.Graded is false
                onChange={() => handleToggleButtonChange("Graded")}
              /> */}
              {/* <label htmlFor="Graded">Graded?</label>
                      <select
                        name="Graded"
                        value={formData.Graded}
                        onChange={handleInputChange}
                        className="form-control"
                      >
                        <option value={false}>No</option>
                        <option value={true}>Yes</option>
                      </select> */}
            </div>
            {formData?.Graded === true?(
              <GradingCompanyAndGradeSelection
                formData={formData}
                setFormData={setFormData}
              />
            ):(

            <div className="form-group">
              
              {/* <input
                type="text"
                name="ConditionCard"
                placeholder="Describe the condition"
                value={formData.ConditionCard}
                onChange={handleInputChange}
                className="form-control"
              /> */}
        {!isPokemon?(<ConditionComponent
  formData={formData}
  setFormData={setFormData}
  disableSelect={false}
  forCreateCardForm={false}
  t={t}
  tabindex={7}
  formSelectStyles={formSelectStyles}
  conditionProfile="sports"
/>):(<ConditionComponent
  formData={formData}
  setFormData={setFormData}
  disableSelect={false}
  forCreateCardForm={false}
  t={t}
  tabindex={7}
  formSelectStyles={formSelectStyles}
  conditionProfile="tcg"
/>)}
            </div>)}

</div>

  <div className="panel">
      <div className="panel-header">
  <h3 className="panel-title">{t('Status')}</h3>
  <LockFieldCheckbox
    fieldId="lockAttributes"
    fieldName="Attributes"
    lockedFields={lockedFields}
    toggleFieldLock={toggleFieldLock}
  />
</div>
  

            <div className="attribute-grid">
              <ToggleButton
                label="PC"
                name="isPC"
                value={formData?.isPC}
                onChange={() => handleToggleButtonChange("isPC")}
                tabindex={9}
              />
              <ToggleButton
                label="For Sale"
                name="isForSale"
                value={formData?.isForSale}
                onChange={() => handleToggleButtonChange("isForSale")}
                tabindex={10}
              />

              <ToggleButton
                label="For Trade"
                name="isForTrade"
                value={formData?.isForTrade}
                onChange={() => handleToggleButtonChange("isForTrade")}
                tabindex={11}
              />

              <ToggleButton
                label="IsOnEbay"
                name="isOnEbay"
                value={formData?.isOnEbay}
                onChange={() => handleToggleButtonChange("isOnEbay")}
                tabindex={12}
              />
            </div>

        {formData?.isForSale === true && (
              <>
              
                {/* <h3>For Sale </h3> */}
                <ForSalePriceAndTemplate
                  initialPrice={formData?.SalePrice}
                  initialShippingTemplate={formData?.ShippingTemplate}
                  onPriceAndShippingChange={handlePriceAndShippingChange}
                  tabIndex={formData?.isForSale?13:null}
                  t={t}
                />
             
              </>
            )}

                   {formData?.isForTrade === true && (
              <>
               
                <ForTradeTradingTemplate
                  userId={userId}
                  setFormData={setFormData}
                  formData={formData}
                  formSelectStyles={formSelectStyles}
                />
  {/* Only show the button if TradingTemplate is valid and not 0 */}
  {formData?.TradingTemplate > 0 && formData?.SeeMore ? (<></>
      // <ToggleButton
      //   label="SeeLess"
      //   name="SeeMore"
      //   value={!formData?.SeeMore}
      //   onChange={() => handleToggleButtonChange("SeeMore")}
      // />
    ) : (
      formData?.TradingTemplate > 0 && (
        <ToggleButton
          label="SeeMore"
          name="SeeMore"
          value={formData?.SeeMore}
          onChange={() => handleToggleButtonChange("SeeMore")}
        />
      )
    )}
  </>
)}
    
     
    </div>
      <div className="panel">
        <div className="panel-header">
              <p className="panel-title">{t('Value')}
</p> <p
  type="text"
  onClick={() => {
    const ebayUrl = generateEbaySearchUrl(formData, newVariation.label);
    window.open(ebayUrl, "_blank");
  }}
   className="see-comps-button"
  title="Open eBay search with your selected card data"
>
  <img src={loupeIcon} style={{maxWidth:'1.5rem'}}/>{t('See Comps on eBay')}
  </p>
  </div>
            <div className="form-group">
              <label htmlFor="EstimateValue">{t("Estimate Value")}($):</label>
              <div className="flex-h">
              <input
  type="text"
  name="EstimateValue"
  placeholder={t("Estimate Value")}
  value={formData?.EstimateValue}
  onInput={handleNumericInputChange} // Call numeric input handler
  className="form-control reg"
  tabIndex={formData?.isForSale?18:16}
  onFocus={(e) => e.target.select()}
  style={{width:'40%',marginRight:'1vw',padding:'10px'}}
/>

</div>
            </div>
            <div className="form-group">
              <label htmlFor="PaidPrice">{t("Price Paid")}($):</label>
              <div className="input-group">
                <div className="input-group-prepend"></div>
                <input
  type="text"
  name="PaidPrice"
  placeholder={t("Price Paid")}
  value={formData?.PaidPrice}
  onInput={handleNumericInputChange} // Call numeric input handler
  className="form-control reg"
  tabIndex={formData?.isForSale?19:17}
  onFocus={(e) => e.target.select()}
  style={{padding:'10px'}}
/>
              </div>
            </div>
            </div>
      
      
          </div>

          <div className="image-upload-row">
                    <div className="panel">
              <p className="panel-title">{t('Other')}</p>
            <div className="form-group">
              <label htmlFor="Location">{t("Location")}:</label>
              <div className="lockGroup">
                <input
                  type="text"
                  name="Location"
                  placeholder={`${t("Location")}:(C21)`}
                  value={formData?.Location}
                  onChange={handleInputChange}
                  className="form-control reg"
                  tabIndex={formData?.isForSale?20:18}
                  onFocus={(e) => e.target.select()}
                  
                />

                <LockFieldCheckbox
                  fieldId="lockLocation"
                  fieldName="Location"
                  lockedFields={lockedFields}
                  toggleFieldLock={toggleFieldLock}
                />
              </div>

            </div>
              <div className="form-group">
              {!allowCreateNewCollection ? (
                <>
                  <div className="form-group">
                    <label htmlFor="Collection">
                      {t("Pre-Assign To Collection")}:
                    </label>
                    <div className="lockGroup" style={{width:'22rem',maxWidth:'100%'}}>
                     
<Select
  className="form-control"
                               styles={formSelectStyles}
    menuPortalTarget={document.body}
    menuPosition="fixed"
    menuPlacement="auto"
  tabIndex={formData?.isForSale ? 21 : 19}
  value={
    selectedCollectionLive.Title
  }
  onChange={(selectedOption) => {
    if (!selectedOption) return;
    setSelectedCollectionLive(selectedOption); // ✅ set the full collection object
  }}
  options={collections.map((collection) => ({
    value: collection.ListId,
    label:
      parseInt(collection.ListId) !== 0
        ? `${collection.Title} (${collection.collectionCount})`
        : t("Not Assign"),
   
  }))}
  isSearchable={false}
/>

                      <MySvgButtonPlus onClickDo={handleCreateNewButtonClick} withBox={true} />
                    </div>
                  </div>
                  
                </>
              ) : (
                <>
                  {" "}
                  {createCollectionLabelNewCollection}
                  {collectionNameInputNewCollection}
                  <div className="flex-h">
                    {confirmButtonNewCollection}
                    {cancelButtonNewCollection}
                  </div>
                </>
              )}
           
            {/* {parseInt(selectedCollectionLive)!==0&&<button onClick={()=>handleRenameButtonClick()}>{`Rename`}</button>}
               {allowCollectionRename&&displayRenameCollectionForm()} */}

</div>
          </div>
          <div className="right-section" style={{padding:'0'}}>
  <div className="form-group fitContent" >

<div
  className={`drop-area ${isDragging ? 'dragging' : ''} ${formData?.Image ? 'has-image' : ''}`}
  onDragOver={handleDragOver}
  onDrop={(e) => handleDrop(e, 'Image')}
  onDragEnter={() => setIsDragging(true)}
  onDragLeave={() => setIsDragging(false)}
  onClick={() => { if (!formData?.Image) fileFrontRef.current?.click(); }}
>
  <input
    ref={fileFrontRef}
    type="file"
    id="fileUpload1"
    name="Image"
    accept="image/*"
    onChange={handleImageChange}
    className="hidden-file-input"
  />

  {!formData?.Image && (
    <div className="custom-file-button">
      <img src={SelectorIcon} alt="" />
      <h3>{t("Front")}</h3>
      <p>{t("Drag and drop")}</p>
    </div>
  )}

  {formData?.Image && (
    <>
      <img className="preview" src={previewImage} alt="" />
      <div className="overlay-buttons">
        <button
          className="btn"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); fileFrontRef.current?.click(); }}
        >
          {t("Replace")}
        </button>
        <button
          className="btn"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); removeImage("Image"); }}
        >
          {t("Remove")}
        </button>
      </div>
    </>
  )}
</div>



    {/* Loading Spinner */}
    {isUploading && <div className="loading-spinner">{t('Uploading...')}</div>}

    {/* Preview */}
    {/* {formData?.Image && (
      <div>
        {viewPreview ? (
          <>
           
            <BigShowCompleteCard  formData={formData} isForCreate={true} showProfile={false} newVariation={newVariation.label} previewImage={previewImage} useMinHeight={false} showPrice={true} />
           <button onClick={() => setViewPreview(!viewPreview)}>
              {t("ImageOnly")}
            </button>
          </>
        ) : (
          <>
            <div className="cardcontentForm">
              <div className="card">
                <div className="img">
                  <img
                    className="card-image"
                    src={previewImage}
                    alt="Card Preview"
                  />
                </div>
              </div>
            </div>
            <div>
              <button onClick={() => setViewPreview(!viewPreview)}>
                {t("Preview")}
              </button>
            </div>
          </>
        )}
      </div>
    )} */}
  </div>
</div>

<div className="right-picture">
  <div className="form-group fitContent" style={{textAlign: 'center',}}>
    
    
    {/* Drag and Drop area for Back Image */}
<div
  className={`drop-area ${isDragging ? 'dragging' : ''} ${formData?.ImageBack ? 'has-image' : ''}`}
  onDragOver={handleDragOver}
  onDrop={(e) => handleDrop(e, 'ImageBack')}
  onDragEnter={() => setIsDragging(true)}
  onDragLeave={() => setIsDragging(false)}
  onClick={() => { if (!formData?.ImageBack) fileBackRef.current?.click(); }}
>
  <input
    ref={fileBackRef}
    type="file"
    id="fileUpload2"
    name="ImageBack"
    accept="image/*"
    onChange={handleImageChange}
    className="hidden-file-input"
  />

  {!formData?.ImageBack && (
    <div className="custom-file-button">
      <img src={SelectorIcon} alt="" />
      <h3>{t("Back")}</h3>
      <p>{t("Drag and drop")}</p>
    </div>
  )}

  {formData?.ImageBack && (
    <>
      <img className="preview" src={previewImageBack} alt="" />
      <div className="overlay-buttons">
        <button
          className="btn"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); fileBackRef.current?.click(); }}
        >
          {t("Replace")}
        </button>
        <button
          className="btn"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); removeImage("ImageBack"); }}
        >
          {t("Remove")}
        </button>
      </div>
    </>
  )}
</div>

    
    {/* Loading Spinner */}
    {isUploading && <div className="loading-spinner">{t('Uploading...')}
</div>}

{/* <div className="loading-spinner">Uploading...</div> */}
 

  </div>
               
</div>

{/* <button type="button" onClick={scanFrontWithXimilar} className="ml-2 px-2 py-1 rounded bg-blue-600 text-white">
  AI Scan (console)
</button> */}

{/* Actions row */}
<div className="form-actions">
  <button
    type="button"
    className="btn-discard"
    onClick={()=>resetFormData()} // <- make this reset / close
  >
    {t("Discard")}
  </button>

  <button
    type="button"
    className="btn-submit"
    onClick={handleSubmit}
    disabled={isLoading}
    tabIndex={formData?.isForSale ? 22 : 20}
  >
    {isLoading && <span className="spinner" aria-hidden="true" />}
    {isLoading ? t("Creating Card...") : t("Add Card")}
  </button>
</div>




</div>


         
          {errorMessage && <p>Error: {errorMessage}</p>}
          {successMessage && <p>{successMessage}</p>}
        </form>
      
    </>
  );
}

export default CreateCardForm;
